// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/icons/scroll-bar-up-arrow.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/images/icons/scroll-bar-down-arrow.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAANElEQVQYV2NkIAAYiVbw//9/Y6DiM1ANJoyMjGdBbLgJQAX/kU0DKgDLkaQAvxW4HEvQFwCRcxIJK1XznAAAAABJRU5ErkJggg==", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAALElEQVQYV2NkIAAYSVFgDFR8BqrBBEifBbGRTfiPZhpYjiQFBK3A6l6CvgAAE9kGCd1mvgEAAAAASUVORK5CYII=", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
== malihu jquery custom scrollbar plugin ==
*/

/*
CONTENTS: 
	1. BASIC STYLE - Plugin's basic/essential CSS properties (normally, should not be edited). 
	2. VERTICAL SCROLLBAR - Positioning and dimensions of vertical scrollbar. 
	3. HORIZONTAL SCROLLBAR - Positioning and dimensions of horizontal scrollbar.
	4. VERTICAL AND HORIZONTAL SCROLLBARS - Positioning and dimensions of 2-axis scrollbars. 
	5. TRANSITIONS - CSS3 transitions for hover events, auto-expanded and auto-hidden scrollbars. 
	6. SCROLLBAR COLORS, OPACITY AND BACKGROUNDS 
		6.1 THEMES - Scrollbar colors, opacity, dimensions, backgrounds etc. via ready-to-use themes.
*/

/* 
------------------------------------------------------------------------------------------------------------------------
1. BASIC STYLE  
------------------------------------------------------------------------------------------------------------------------
*/

.mCustomScrollbar {
  -ms-touch-action: pinch-zoom;
  touch-action: pinch-zoom; /* direct pointer events to js */
}
.mCustomScrollbar.mCS_no_scrollbar,
.mCustomScrollbar.mCS_touch_action {
  -ms-touch-action: auto;
  touch-action: auto;
}

.mCustomScrollBox {
  /* contains plugin's markup */
  position: relative;
  overflow: hidden;
  height: 100%;
  max-width: 100%;
  outline: none;
  direction: ltr;
}

.mCSB_container {
  /* contains the original content */
  overflow: hidden;
  width: auto;
  height: auto;
}

/* 
------------------------------------------------------------------------------------------------------------------------
2. VERTICAL SCROLLBAR 
y-axis
------------------------------------------------------------------------------------------------------------------------
*/

.mCSB_inside > .mCSB_container {
  margin-right: 30px;
}

.mCSB_container.mCS_no_scrollbar_y.mCS_y_hidden {
  margin-right: 0;
} /* non-visible scrollbar */

.mCS-dir-rtl > .mCSB_inside > .mCSB_container {
  /* RTL direction/left-side scrollbar */
  margin-right: 0;
  margin-left: 30px;
}

.mCS-dir-rtl > .mCSB_inside > .mCSB_container.mCS_no_scrollbar_y.mCS_y_hidden {
  margin-left: 0;
} /* RTL direction/left-side scrollbar */

.mCSB_scrollTools {
  /* contains scrollbar markup (draggable element, dragger rail, buttons etc.) */
  position: absolute;
  width: 16px;
  height: auto;
  left: auto;
  top: 0;
  right: 0;
  bottom: 0;
}

.mCSB_outside + .mCSB_scrollTools {
  right: -26px;
} /* scrollbar position: outside */

.mCS-dir-rtl > .mCSB_inside > .mCSB_scrollTools,
.mCS-dir-rtl > .mCSB_outside + .mCSB_scrollTools {
  /* RTL direction/left-side scrollbar */
  right: auto;
  left: 0;
}

.mCS-dir-rtl > .mCSB_outside + .mCSB_scrollTools {
  left: -26px;
} /* RTL direction/left-side scrollbar (scrollbar position: outside) */

.mCSB_scrollTools .mCSB_draggerContainer {
  /* contains the draggable element and dragger rail markup */
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  height: auto;
}

.mCSB_scrollTools a + .mCSB_draggerContainer {
  margin: 20px 0;
}

.mCSB_scrollTools .mCSB_draggerRail {
  width: 2px;
  height: 100%;
  margin: 0 auto;
  -webkit-border-radius: 16px;
  -moz-border-radius: 16px;
  border-radius: 16px;
}

.mCSB_scrollTools .mCSB_dragger {
  /* the draggable element */
  cursor: pointer;
  width: 100%;
  height: 30px; /* minimum dragger height */
  z-index: 1;
}

.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar {
  /* the dragger element */
  position: relative;
  width: 4px;
  height: 100%;
  margin: 0 auto;
  -webkit-border-radius: 16px;
  -moz-border-radius: 16px;
  border-radius: 16px;
  text-align: center;
}

.mCSB_scrollTools_vertical.mCSB_scrollTools_onDrag_expand
  .mCSB_dragger.mCSB_dragger_onDrag_expanded
  .mCSB_dragger_bar,
.mCSB_scrollTools_vertical.mCSB_scrollTools_onDrag_expand
  .mCSB_draggerContainer:hover
  .mCSB_dragger
  .mCSB_dragger_bar {
  width: 12px; /* auto-expanded scrollbar */
}

.mCSB_scrollTools_vertical.mCSB_scrollTools_onDrag_expand
  .mCSB_dragger.mCSB_dragger_onDrag_expanded
  + .mCSB_draggerRail,
.mCSB_scrollTools_vertical.mCSB_scrollTools_onDrag_expand
  .mCSB_draggerContainer:hover
  .mCSB_draggerRail {
  width: 8px; /* auto-expanded scrollbar */
}

.mCSB_scrollTools .mCSB_buttonUp,
.mCSB_scrollTools .mCSB_buttonDown {
  display: block;
  position: absolute;
  height: 20px;
  width: 100%;
  overflow: hidden;
  margin: 0 auto;
  cursor: pointer;
}

.mCSB_scrollTools .mCSB_buttonDown {
  bottom: 0;
}

/* 
------------------------------------------------------------------------------------------------------------------------
3. HORIZONTAL SCROLLBAR 
x-axis
------------------------------------------------------------------------------------------------------------------------
*/

.mCSB_horizontal.mCSB_inside > .mCSB_container {
  margin-right: 0;
  margin-bottom: 30px;
}

.mCSB_horizontal.mCSB_outside > .mCSB_container {
  min-height: 100%;
}

.mCSB_horizontal > .mCSB_container.mCS_no_scrollbar_x.mCS_x_hidden {
  margin-bottom: 0;
} /* non-visible scrollbar */

.mCSB_scrollTools.mCSB_scrollTools_horizontal {
  width: auto;
  height: 16px;
  top: auto;
  right: 0;
  bottom: 0;
  left: 0;
}

.mCustomScrollBox + .mCSB_scrollTools.mCSB_scrollTools_horizontal,
.mCustomScrollBox
  + .mCSB_scrollTools
  + .mCSB_scrollTools.mCSB_scrollTools_horizontal {
  bottom: -26px;
} /* scrollbar position: outside */

.mCSB_scrollTools.mCSB_scrollTools_horizontal a + .mCSB_draggerContainer {
  margin: 0 20px;
}

.mCSB_scrollTools.mCSB_scrollTools_horizontal .mCSB_draggerRail {
  width: 100%;
  height: 2px;
  margin: 7px 0;
}

.mCSB_scrollTools.mCSB_scrollTools_horizontal .mCSB_dragger {
  width: 30px; /* minimum dragger width */
  height: 100%;
  left: 0;
}

.mCSB_scrollTools.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar {
  width: 100%;
  height: 4px;
  margin: 6px auto;
}

.mCSB_scrollTools_horizontal.mCSB_scrollTools_onDrag_expand
  .mCSB_dragger.mCSB_dragger_onDrag_expanded
  .mCSB_dragger_bar,
.mCSB_scrollTools_horizontal.mCSB_scrollTools_onDrag_expand
  .mCSB_draggerContainer:hover
  .mCSB_dragger
  .mCSB_dragger_bar {
  height: 12px; /* auto-expanded scrollbar */
  margin: 2px auto;
}

.mCSB_scrollTools_horizontal.mCSB_scrollTools_onDrag_expand
  .mCSB_dragger.mCSB_dragger_onDrag_expanded
  + .mCSB_draggerRail,
.mCSB_scrollTools_horizontal.mCSB_scrollTools_onDrag_expand
  .mCSB_draggerContainer:hover
  .mCSB_draggerRail {
  height: 8px; /* auto-expanded scrollbar */
  margin: 4px 0;
}

.mCSB_scrollTools.mCSB_scrollTools_horizontal .mCSB_buttonLeft,
.mCSB_scrollTools.mCSB_scrollTools_horizontal .mCSB_buttonRight {
  display: block;
  position: absolute;
  width: 20px;
  height: 100%;
  overflow: hidden;
  margin: 0 auto;
  cursor: pointer;
}

.mCSB_scrollTools.mCSB_scrollTools_horizontal .mCSB_buttonLeft {
  left: 0;
}

.mCSB_scrollTools.mCSB_scrollTools_horizontal .mCSB_buttonRight {
  right: 0;
}

/* 
------------------------------------------------------------------------------------------------------------------------
4. VERTICAL AND HORIZONTAL SCROLLBARS 
yx-axis 
------------------------------------------------------------------------------------------------------------------------
*/

.mCSB_container_wrapper {
  position: absolute;
  height: auto;
  width: auto;
  overflow: hidden;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin-right: 30px;
  margin-bottom: 30px;
}

.mCSB_container_wrapper > .mCSB_container {
  padding-right: 30px;
  padding-bottom: 30px;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

.mCSB_vertical_horizontal > .mCSB_scrollTools.mCSB_scrollTools_vertical {
  bottom: 20px;
}

.mCSB_vertical_horizontal > .mCSB_scrollTools.mCSB_scrollTools_horizontal {
  right: 20px;
}

/* non-visible horizontal scrollbar */
.mCSB_container_wrapper.mCS_no_scrollbar_x.mCS_x_hidden
  + .mCSB_scrollTools.mCSB_scrollTools_vertical {
  bottom: 0;
}

/* non-visible vertical scrollbar/RTL direction/left-side scrollbar */
.mCSB_container_wrapper.mCS_no_scrollbar_y.mCS_y_hidden
  + .mCSB_scrollTools
  ~ .mCSB_scrollTools.mCSB_scrollTools_horizontal,
.mCS-dir-rtl
  > .mCustomScrollBox.mCSB_vertical_horizontal.mCSB_inside
  > .mCSB_scrollTools.mCSB_scrollTools_horizontal {
  right: 0;
}

/* RTL direction/left-side scrollbar */
.mCS-dir-rtl
  > .mCustomScrollBox.mCSB_vertical_horizontal.mCSB_inside
  > .mCSB_scrollTools.mCSB_scrollTools_horizontal {
  left: 20px;
}

/* non-visible scrollbar/RTL direction/left-side scrollbar */
.mCS-dir-rtl
  > .mCustomScrollBox.mCSB_vertical_horizontal.mCSB_inside
  > .mCSB_container_wrapper.mCS_no_scrollbar_y.mCS_y_hidden
  + .mCSB_scrollTools
  ~ .mCSB_scrollTools.mCSB_scrollTools_horizontal {
  left: 0;
}

.mCS-dir-rtl > .mCSB_inside > .mCSB_container_wrapper {
  /* RTL direction/left-side scrollbar */
  margin-right: 0;
  margin-left: 30px;
}

.mCSB_container_wrapper.mCS_no_scrollbar_y.mCS_y_hidden > .mCSB_container {
  padding-right: 0;
}

.mCSB_container_wrapper.mCS_no_scrollbar_x.mCS_x_hidden > .mCSB_container {
  padding-bottom: 0;
}

.mCustomScrollBox.mCSB_vertical_horizontal.mCSB_inside
  > .mCSB_container_wrapper.mCS_no_scrollbar_y.mCS_y_hidden {
  margin-right: 0; /* non-visible scrollbar */
  margin-left: 0;
}

/* non-visible horizontal scrollbar */
.mCustomScrollBox.mCSB_vertical_horizontal.mCSB_inside
  > .mCSB_container_wrapper.mCS_no_scrollbar_x.mCS_x_hidden {
  margin-bottom: 0;
}

/* 
------------------------------------------------------------------------------------------------------------------------
5. TRANSITIONS  
------------------------------------------------------------------------------------------------------------------------
*/

/* Kill all transitions */
/*
	.mCSB_scrollTools, 
	.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar, 
	.mCSB_scrollTools .mCSB_buttonUp,
	.mCSB_scrollTools .mCSB_buttonDown,
	.mCSB_scrollTools .mCSB_buttonLeft,
	.mCSB_scrollTools .mCSB_buttonRight{
		-webkit-transition: opacity .2s ease-in-out, background-color .2s ease-in-out;
		-moz-transition: opacity .2s ease-in-out, background-color .2s ease-in-out;
		-o-transition: opacity .2s ease-in-out, background-color .2s ease-in-out;
		transition: opacity .2s ease-in-out, background-color .2s ease-in-out;
	}
	
	.mCSB_scrollTools_vertical.mCSB_scrollTools_onDrag_expand .mCSB_dragger_bar, 
	.mCSB_scrollTools_vertical.mCSB_scrollTools_onDrag_expand .mCSB_draggerRail, 
	.mCSB_scrollTools_horizontal.mCSB_scrollTools_onDrag_expand .mCSB_dragger_bar, 
	.mCSB_scrollTools_horizontal.mCSB_scrollTools_onDrag_expand .mCSB_draggerRail{
		-webkit-transition: width .2s ease-out .2s, height .2s ease-out .2s, 
					margin-left .2s ease-out .2s, margin-right .2s ease-out .2s, 
					margin-top .2s ease-out .2s, margin-bottom .2s ease-out .2s,
					opacity .2s ease-in-out, background-color .2s ease-in-out; 
		-moz-transition: width .2s ease-out .2s, height .2s ease-out .2s, 
					margin-left .2s ease-out .2s, margin-right .2s ease-out .2s, 
					margin-top .2s ease-out .2s, margin-bottom .2s ease-out .2s,
					opacity .2s ease-in-out, background-color .2s ease-in-out; 
		-o-transition: width .2s ease-out .2s, height .2s ease-out .2s, 
					margin-left .2s ease-out .2s, margin-right .2s ease-out .2s, 
					margin-top .2s ease-out .2s, margin-bottom .2s ease-out .2s,
					opacity .2s ease-in-out, background-color .2s ease-in-out; 
		transition: width .2s ease-out .2s, height .2s ease-out .2s, 
					margin-left .2s ease-out .2s, margin-right .2s ease-out .2s, 
					margin-top .2s ease-out .2s, margin-bottom .2s ease-out .2s,
					opacity .2s ease-in-out, background-color .2s ease-in-out; 
	}
    */

/* 
------------------------------------------------------------------------------------------------------------------------
6. SCROLLBAR COLORS, OPACITY AND BACKGROUNDS  
------------------------------------------------------------------------------------------------------------------------
*/

/* 
	----------------------------------------
	6.1 THEMES 
	----------------------------------------
	*/

/* default theme ("light") */

.mCSB_scrollTools {
  opacity: 0.75;
  filter: 'alpha(opacity=75)';
  -ms-filter: 'alpha(opacity=75)';
}

.mCS-autoHide > .mCustomScrollBox > .mCSB_scrollTools,
.mCS-autoHide > .mCustomScrollBox ~ .mCSB_scrollTools {
  opacity: 0;
  filter: 'alpha(opacity=0)';
  -ms-filter: 'alpha(opacity=0)';
}

/* Get rid of drag effects */
/*
	.mCustomScrollbar > .mCustomScrollBox > .mCSB_scrollTools.mCSB_scrollTools_onDrag,
	.mCustomScrollbar > .mCustomScrollBox ~ .mCSB_scrollTools.mCSB_scrollTools_onDrag,
	.mCustomScrollBox:hover > .mCSB_scrollTools,
	.mCustomScrollBox:hover ~ .mCSB_scrollTools,
	.mCS-autoHide:hover > .mCustomScrollBox > .mCSB_scrollTools,
	.mCS-autoHide:hover > .mCustomScrollBox ~ .mCSB_scrollTools{ opacity: 1; filter: "alpha(opacity=100)"; -ms-filter: "alpha(opacity=100)"; }
    */

.mCSB_scrollTools .mCSB_draggerRail {
  background-color: #000;
  background-color: rgba(0, 0, 0, 0.4);
  filter: 'alpha(opacity=40)';
  -ms-filter: 'alpha(opacity=40)';
}

.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar {
  background-color: #fff;
  background-color: rgba(255, 255, 255, 0.75);
  filter: 'alpha(opacity=75)';
  -ms-filter: 'alpha(opacity=75)';
}

.mCSB_scrollTools .mCSB_dragger:hover .mCSB_dragger_bar {
  background-color: #fff;
  background-color: rgba(255, 255, 255, 0.85);
  filter: 'alpha(opacity=85)';
  -ms-filter: 'alpha(opacity=85)';
}

.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar,
.mCSB_scrollTools .mCSB_dragger.mCSB_dragger_onDrag .mCSB_dragger_bar {
  background-color: #fff;
  background-color: rgba(255, 255, 255, 0.9);
  filter: 'alpha(opacity=90)';
  -ms-filter: 'alpha(opacity=90)';
}

.mCSB_scrollTools .mCSB_buttonUp,
.mCSB_scrollTools .mCSB_buttonDown,
.mCSB_scrollTools .mCSB_buttonLeft,
.mCSB_scrollTools .mCSB_buttonRight {
  /* background-image: url(mCSB_buttons.png); css sprites */
  background-repeat: no-repeat;
  opacity: 0.4;
  filter: 'alpha(opacity=40)';
  -ms-filter: 'alpha(opacity=40)';
}

.mCSB_scrollTools .mCSB_buttonUp {
  background-position: 0 0;
  /* 
		sprites locations 
		light: 0 0, -16px 0, -32px 0, -48px 0, 0 -72px, -16px -72px, -32px -72px
		dark: -80px 0, -96px 0, -112px 0, -128px 0, -80px -72px, -96px -72px, -112px -72px
		*/
}

.mCSB_scrollTools .mCSB_buttonDown {
  background-position: 0 -20px;
  /* 
		sprites locations
		light: 0 -20px, -16px -20px, -32px -20px, -48px -20px, 0 -92px, -16px -92px, -32px -92px
		dark: -80px -20px, -96px -20px, -112px -20px, -128px -20px, -80px -92px, -96px -92px, -112 -92px
		*/
}

.mCSB_scrollTools .mCSB_buttonLeft {
  background-position: 0 -40px;
  /* 
		sprites locations 
		light: 0 -40px, -20px -40px, -40px -40px, -60px -40px, 0 -112px, -20px -112px, -40px -112px
		dark: -80px -40px, -100px -40px, -120px -40px, -140px -40px, -80px -112px, -100px -112px, -120px -112px
		*/
}

.mCSB_scrollTools .mCSB_buttonRight {
  background-position: 0 -56px;
  /* 
		sprites locations 
		light: 0 -56px, -20px -56px, -40px -56px, -60px -56px, 0 -128px, -20px -128px, -40px -128px
		dark: -80px -56px, -100px -56px, -120px -56px, -140px -56px, -80px -128px, -100px -128px, -120px -128px
		*/
}

.mCSB_scrollTools .mCSB_buttonUp:hover,
.mCSB_scrollTools .mCSB_buttonDown:hover,
.mCSB_scrollTools .mCSB_buttonLeft:hover,
.mCSB_scrollTools .mCSB_buttonRight:hover {
  opacity: 0.75;
  filter: 'alpha(opacity=75)';
  -ms-filter: 'alpha(opacity=75)';
}

.mCSB_scrollTools .mCSB_buttonUp:active,
.mCSB_scrollTools .mCSB_buttonDown:active,
.mCSB_scrollTools .mCSB_buttonLeft:active,
.mCSB_scrollTools .mCSB_buttonRight:active {
  opacity: 0.9;
  filter: 'alpha(opacity=90)';
  -ms-filter: 'alpha(opacity=90)';
}

/* theme: "bai" */

.mCS-bai .mCSB_draggerContainer {
  background-color: #a1a097;
}

.mCS-bai.mCSB_scrollTools .mCSB_draggerRail {
  background-color: #a1a097;
}

.mCS-bai .mCSB_scrollTools {
  width: 14px;
}

.mCS-bai .mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar {
  width: 8px;
  -webkit-border-radius: initial;
  -moz-border-radius: initial;
  border-radius: initial;
}

.mCS-bai.mCSB_scrollTools .mCSB_buttonUp,
.mCS-bai.mCSB_scrollTools .mCSB_buttonDown,
.mCS-bai.mCSB_scrollTools .mCSB_buttonLeft,
.mCS-bai.mCSB_scrollTools .mCSB_buttonRight {
  background-color: #a1a097;
  opacity: initial;
}

.mCS-bai.mCSB_scrollTools .mCSB_buttonUp {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: 8px 8px;
  background-position: 3px 4px;
}

.mCS-bai.mCSB_scrollTools .mCSB_buttonDown {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-size: 8px 8px;
  background-position: 3px 8px;
}

.mCS-bai .mCSB_container_wrapper > .mCSB_container {
  padding-right: 0;
}

.MCS-bai .mCSB_scrollTools {
  opacity: initial;
}

.mCS-bai .mCSB_container_wrapper {
  margin-right: 22px;
}

.mCS-bai.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar {
  background-color: #e5e5e5;
}

/*
	.mCS-bai.mCSB_scrollTools .mCSB_dragger:hover .mCSB_dragger_bar{ background-color: rgba(0,0,0,0.85); }
    */

.mCS-bai.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar,
    /*
	.mCS-bai.mCSB_scrollTools .mCSB_dragger.mCSB_dragger_onDrag .mCSB_dragger_bar{ background-color: rgba(0,0,0,0.9); }
    */

	.mCS-bai.mCSB_scrollTools .mCSB_buttonLeft {
  background-position: -80px -40px;
}

.mCS-bai.mCSB_scrollTools .mCSB_buttonRight {
  background-position: -80px -56px;
}

/* theme: "dark" */

.mCS-dark.mCSB_scrollTools .mCSB_draggerRail {
  background-color: #000;
  background-color: rgba(0, 0, 0, 0.15);
}

.mCS-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar {
  background-color: #000;
  background-color: rgba(0, 0, 0, 0.75);
}

.mCS-dark.mCSB_scrollTools .mCSB_dragger:hover .mCSB_dragger_bar {
  background-color: rgba(0, 0, 0, 0.85);
}

.mCS-dark.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar,
    /*
	.mCS-dark.mCSB_scrollTools .mCSB_dragger.mCSB_dragger_onDrag .mCSB_dragger_bar{ background-color: rgba(0,0,0,0.9); }
    */

	.mCS-dark.mCSB_scrollTools .mCSB_buttonUp {
  background-position: -80px 0;
}

.mCS-dark.mCSB_scrollTools .mCSB_buttonDown {
  background-position: -80px -20px;
}

.mCS-dark.mCSB_scrollTools .mCSB_buttonLeft {
  background-position: -80px -40px;
}

.mCS-dark.mCSB_scrollTools .mCSB_buttonRight {
  background-position: -80px -56px;
}

/* ---------------------------------------- */

/* theme: "light-2", "dark-2" */

.mCS-light-2.mCSB_scrollTools .mCSB_draggerRail,
.mCS-dark-2.mCSB_scrollTools .mCSB_draggerRail {
  width: 4px;
  background-color: #fff;
  background-color: rgba(255, 255, 255, 0.1);
  -webkit-border-radius: 1px;
  -moz-border-radius: 1px;
  border-radius: 1px;
}

.mCS-light-2.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,
.mCS-dark-2.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar {
  width: 4px;
  background-color: #fff;
  background-color: rgba(255, 255, 255, 0.75);
  -webkit-border-radius: 1px;
  -moz-border-radius: 1px;
  border-radius: 1px;
}

.mCS-light-2.mCSB_scrollTools_horizontal .mCSB_draggerRail,
.mCS-dark-2.mCSB_scrollTools_horizontal .mCSB_draggerRail,
.mCS-light-2.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar,
.mCS-dark-2.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar {
  width: 100%;
  height: 4px;
  margin: 6px auto;
}

.mCS-light-2.mCSB_scrollTools .mCSB_dragger:hover .mCSB_dragger_bar {
  background-color: #fff;
  background-color: rgba(255, 255, 255, 0.85);
}

.mCS-light-2.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar,
.mCS-light-2.mCSB_scrollTools
  .mCSB_dragger.mCSB_dragger_onDrag
  .mCSB_dragger_bar {
  background-color: #fff;
  background-color: rgba(255, 255, 255, 0.9);
}

.mCS-light-2.mCSB_scrollTools .mCSB_buttonUp {
  background-position: -32px 0;
}

.mCS-light-2.mCSB_scrollTools .mCSB_buttonDown {
  background-position: -32px -20px;
}

.mCS-light-2.mCSB_scrollTools .mCSB_buttonLeft {
  background-position: -40px -40px;
}

.mCS-light-2.mCSB_scrollTools .mCSB_buttonRight {
  background-position: -40px -56px;
}

/* theme: "dark-2" */

.mCS-dark-2.mCSB_scrollTools .mCSB_draggerRail {
  background-color: #000;
  background-color: rgba(0, 0, 0, 0.1);
  -webkit-border-radius: 1px;
  -moz-border-radius: 1px;
  border-radius: 1px;
}

.mCS-dark-2.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar {
  background-color: #000;
  background-color: rgba(0, 0, 0, 0.75);
  -webkit-border-radius: 1px;
  -moz-border-radius: 1px;
  border-radius: 1px;
}

.mCS-dark-2.mCSB_scrollTools .mCSB_dragger:hover .mCSB_dragger_bar {
  background-color: #000;
  background-color: rgba(0, 0, 0, 0.85);
}

.mCS-dark-2.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar,
.mCS-dark-2.mCSB_scrollTools
  .mCSB_dragger.mCSB_dragger_onDrag
  .mCSB_dragger_bar {
  background-color: #000;
  background-color: rgba(0, 0, 0, 0.9);
}

.mCS-dark-2.mCSB_scrollTools .mCSB_buttonUp {
  background-position: -112px 0;
}

.mCS-dark-2.mCSB_scrollTools .mCSB_buttonDown {
  background-position: -112px -20px;
}

.mCS-dark-2.mCSB_scrollTools .mCSB_buttonLeft {
  background-position: -120px -40px;
}

.mCS-dark-2.mCSB_scrollTools .mCSB_buttonRight {
  background-position: -120px -56px;
}

/* ---------------------------------------- */

/* theme: "light-thick", "dark-thick" */

.mCS-light-thick.mCSB_scrollTools .mCSB_draggerRail,
.mCS-dark-thick.mCSB_scrollTools .mCSB_draggerRail {
  width: 4px;
  background-color: #fff;
  background-color: rgba(255, 255, 255, 0.1);
  -webkit-border-radius: 2px;
  -moz-border-radius: 2px;
  border-radius: 2px;
}

.mCS-light-thick.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,
.mCS-dark-thick.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar {
  width: 6px;
  background-color: #fff;
  background-color: rgba(255, 255, 255, 0.75);
  -webkit-border-radius: 2px;
  -moz-border-radius: 2px;
  border-radius: 2px;
}

.mCS-light-thick.mCSB_scrollTools_horizontal .mCSB_draggerRail,
.mCS-dark-thick.mCSB_scrollTools_horizontal .mCSB_draggerRail {
  width: 100%;
  height: 4px;
  margin: 6px 0;
}

.mCS-light-thick.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar,
.mCS-dark-thick.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar {
  width: 100%;
  height: 6px;
  margin: 5px auto;
}

.mCS-light-thick.mCSB_scrollTools .mCSB_dragger:hover .mCSB_dragger_bar {
  background-color: #fff;
  background-color: rgba(255, 255, 255, 0.85);
}

.mCS-light-thick.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar,
.mCS-light-thick.mCSB_scrollTools
  .mCSB_dragger.mCSB_dragger_onDrag
  .mCSB_dragger_bar {
  background-color: #fff;
  background-color: rgba(255, 255, 255, 0.9);
}

.mCS-light-thick.mCSB_scrollTools .mCSB_buttonUp {
  background-position: -16px 0;
}

.mCS-light-thick.mCSB_scrollTools .mCSB_buttonDown {
  background-position: -16px -20px;
}

.mCS-light-thick.mCSB_scrollTools .mCSB_buttonLeft {
  background-position: -20px -40px;
}

.mCS-light-thick.mCSB_scrollTools .mCSB_buttonRight {
  background-position: -20px -56px;
}

/* theme: "dark-thick" */

.mCS-dark-thick.mCSB_scrollTools .mCSB_draggerRail {
  background-color: #000;
  background-color: rgba(0, 0, 0, 0.1);
  -webkit-border-radius: 2px;
  -moz-border-radius: 2px;
  border-radius: 2px;
}

.mCS-dark-thick.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar {
  background-color: #000;
  background-color: rgba(0, 0, 0, 0.75);
  -webkit-border-radius: 2px;
  -moz-border-radius: 2px;
  border-radius: 2px;
}

.mCS-dark-thick.mCSB_scrollTools .mCSB_dragger:hover .mCSB_dragger_bar {
  background-color: #000;
  background-color: rgba(0, 0, 0, 0.85);
}

.mCS-dark-thick.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar,
.mCS-dark-thick.mCSB_scrollTools
  .mCSB_dragger.mCSB_dragger_onDrag
  .mCSB_dragger_bar {
  background-color: #000;
  background-color: rgba(0, 0, 0, 0.9);
}

.mCS-dark-thick.mCSB_scrollTools .mCSB_buttonUp {
  background-position: -96px 0;
}

.mCS-dark-thick.mCSB_scrollTools .mCSB_buttonDown {
  background-position: -96px -20px;
}

.mCS-dark-thick.mCSB_scrollTools .mCSB_buttonLeft {
  background-position: -100px -40px;
}

.mCS-dark-thick.mCSB_scrollTools .mCSB_buttonRight {
  background-position: -100px -56px;
}

/* ---------------------------------------- */

/* theme: "light-thin", "dark-thin" */

.mCS-light-thin.mCSB_scrollTools .mCSB_draggerRail {
  background-color: #fff;
  background-color: rgba(255, 255, 255, 0.1);
}

.mCS-light-thin.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,
.mCS-dark-thin.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar {
  width: 2px;
}

.mCS-light-thin.mCSB_scrollTools_horizontal .mCSB_draggerRail,
.mCS-dark-thin.mCSB_scrollTools_horizontal .mCSB_draggerRail {
  width: 100%;
}

.mCS-light-thin.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar,
.mCS-dark-thin.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar {
  width: 100%;
  height: 2px;
  margin: 7px auto;
}

/* theme "dark-thin" */

.mCS-dark-thin.mCSB_scrollTools .mCSB_draggerRail {
  background-color: #000;
  background-color: rgba(0, 0, 0, 0.15);
}

.mCS-dark-thin.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar {
  background-color: #000;
  background-color: rgba(0, 0, 0, 0.75);
}

.mCS-dark-thin.mCSB_scrollTools .mCSB_dragger:hover .mCSB_dragger_bar {
  background-color: #000;
  background-color: rgba(0, 0, 0, 0.85);
}

.mCS-dark-thin.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar,
.mCS-dark-thin.mCSB_scrollTools
  .mCSB_dragger.mCSB_dragger_onDrag
  .mCSB_dragger_bar {
  background-color: #000;
  background-color: rgba(0, 0, 0, 0.9);
}

.mCS-dark-thin.mCSB_scrollTools .mCSB_buttonUp {
  background-position: -80px 0;
}

.mCS-dark-thin.mCSB_scrollTools .mCSB_buttonDown {
  background-position: -80px -20px;
}

.mCS-dark-thin.mCSB_scrollTools .mCSB_buttonLeft {
  background-position: -80px -40px;
}

.mCS-dark-thin.mCSB_scrollTools .mCSB_buttonRight {
  background-position: -80px -56px;
}

/* ---------------------------------------- */

/* theme "rounded", "rounded-dark", "rounded-dots", "rounded-dots-dark" */

.mCS-rounded.mCSB_scrollTools .mCSB_draggerRail {
  background-color: #fff;
  background-color: rgba(255, 255, 255, 0.15);
}

.mCS-rounded.mCSB_scrollTools .mCSB_dragger,
.mCS-rounded-dark.mCSB_scrollTools .mCSB_dragger,
.mCS-rounded-dots.mCSB_scrollTools .mCSB_dragger,
.mCS-rounded-dots-dark.mCSB_scrollTools .mCSB_dragger {
  height: 14px;
}

.mCS-rounded.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,
.mCS-rounded-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,
.mCS-rounded-dots.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,
.mCS-rounded-dots-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar {
  width: 14px;
  margin: 0 1px;
}

.mCS-rounded.mCSB_scrollTools_horizontal .mCSB_dragger,
.mCS-rounded-dark.mCSB_scrollTools_horizontal .mCSB_dragger,
.mCS-rounded-dots.mCSB_scrollTools_horizontal .mCSB_dragger,
.mCS-rounded-dots-dark.mCSB_scrollTools_horizontal .mCSB_dragger {
  width: 14px;
}

.mCS-rounded.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar,
.mCS-rounded-dark.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar,
.mCS-rounded-dots.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar,
.mCS-rounded-dots-dark.mCSB_scrollTools_horizontal
  .mCSB_dragger
  .mCSB_dragger_bar {
  height: 14px;
  margin: 1px 0;
}

.mCS-rounded.mCSB_scrollTools_vertical.mCSB_scrollTools_onDrag_expand
  .mCSB_dragger.mCSB_dragger_onDrag_expanded
  .mCSB_dragger_bar,
.mCS-rounded.mCSB_scrollTools_vertical.mCSB_scrollTools_onDrag_expand
  .mCSB_draggerContainer:hover
  .mCSB_dragger
  .mCSB_dragger_bar,
.mCS-rounded-dark.mCSB_scrollTools_vertical.mCSB_scrollTools_onDrag_expand
  .mCSB_dragger.mCSB_dragger_onDrag_expanded
  .mCSB_dragger_bar,
.mCS-rounded-dark.mCSB_scrollTools_vertical.mCSB_scrollTools_onDrag_expand
  .mCSB_draggerContainer:hover
  .mCSB_dragger
  .mCSB_dragger_bar {
  width: 16px; /* auto-expanded scrollbar */
  height: 16px;
  margin: -1px 0;
}

.mCS-rounded.mCSB_scrollTools_vertical.mCSB_scrollTools_onDrag_expand
  .mCSB_dragger.mCSB_dragger_onDrag_expanded
  + .mCSB_draggerRail,
.mCS-rounded.mCSB_scrollTools_vertical.mCSB_scrollTools_onDrag_expand
  .mCSB_draggerContainer:hover
  .mCSB_draggerRail,
.mCS-rounded-dark.mCSB_scrollTools_vertical.mCSB_scrollTools_onDrag_expand
  .mCSB_dragger.mCSB_dragger_onDrag_expanded
  + .mCSB_draggerRail,
.mCS-rounded-dark.mCSB_scrollTools_vertical.mCSB_scrollTools_onDrag_expand
  .mCSB_draggerContainer:hover
  .mCSB_draggerRail {
  width: 4px; /* auto-expanded scrollbar */
}

.mCS-rounded.mCSB_scrollTools_horizontal.mCSB_scrollTools_onDrag_expand
  .mCSB_dragger.mCSB_dragger_onDrag_expanded
  .mCSB_dragger_bar,
.mCS-rounded.mCSB_scrollTools_horizontal.mCSB_scrollTools_onDrag_expand
  .mCSB_draggerContainer:hover
  .mCSB_dragger
  .mCSB_dragger_bar,
.mCS-rounded-dark.mCSB_scrollTools_horizontal.mCSB_scrollTools_onDrag_expand
  .mCSB_dragger.mCSB_dragger_onDrag_expanded
  .mCSB_dragger_bar,
.mCS-rounded-dark.mCSB_scrollTools_horizontal.mCSB_scrollTools_onDrag_expand
  .mCSB_draggerContainer:hover
  .mCSB_dragger
  .mCSB_dragger_bar {
  height: 16px; /* auto-expanded scrollbar */
  width: 16px;
  margin: 0 -1px;
}

.mCS-rounded.mCSB_scrollTools_horizontal.mCSB_scrollTools_onDrag_expand
  .mCSB_dragger.mCSB_dragger_onDrag_expanded
  + .mCSB_draggerRail,
.mCS-rounded.mCSB_scrollTools_horizontal.mCSB_scrollTools_onDrag_expand
  .mCSB_draggerContainer:hover
  .mCSB_draggerRail,
.mCS-rounded-dark.mCSB_scrollTools_horizontal.mCSB_scrollTools_onDrag_expand
  .mCSB_dragger.mCSB_dragger_onDrag_expanded
  + .mCSB_draggerRail,
.mCS-rounded-dark.mCSB_scrollTools_horizontal.mCSB_scrollTools_onDrag_expand
  .mCSB_draggerContainer:hover
  .mCSB_draggerRail {
  height: 4px; /* auto-expanded scrollbar */
  margin: 6px 0;
}

.mCS-rounded.mCSB_scrollTools .mCSB_buttonUp {
  background-position: 0 -72px;
}

.mCS-rounded.mCSB_scrollTools .mCSB_buttonDown {
  background-position: 0 -92px;
}

.mCS-rounded.mCSB_scrollTools .mCSB_buttonLeft {
  background-position: 0 -112px;
}

.mCS-rounded.mCSB_scrollTools .mCSB_buttonRight {
  background-position: 0 -128px;
}

/* theme "rounded-dark", "rounded-dots-dark" */

.mCS-rounded-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,
.mCS-rounded-dots-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar {
  background-color: #000;
  background-color: rgba(0, 0, 0, 0.75);
}

.mCS-rounded-dark.mCSB_scrollTools .mCSB_draggerRail {
  background-color: #000;
  background-color: rgba(0, 0, 0, 0.15);
}

.mCS-rounded-dark.mCSB_scrollTools .mCSB_dragger:hover .mCSB_dragger_bar,
.mCS-rounded-dots-dark.mCSB_scrollTools .mCSB_dragger:hover .mCSB_dragger_bar {
  background-color: #000;
  background-color: rgba(0, 0, 0, 0.85);
}

.mCS-rounded-dark.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar,
.mCS-rounded-dark.mCSB_scrollTools
  .mCSB_dragger.mCSB_dragger_onDrag
  .mCSB_dragger_bar,
.mCS-rounded-dots-dark.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar,
.mCS-rounded-dots-dark.mCSB_scrollTools
  .mCSB_dragger.mCSB_dragger_onDrag
  .mCSB_dragger_bar {
  background-color: #000;
  background-color: rgba(0, 0, 0, 0.9);
}

.mCS-rounded-dark.mCSB_scrollTools .mCSB_buttonUp {
  background-position: -80px -72px;
}

.mCS-rounded-dark.mCSB_scrollTools .mCSB_buttonDown {
  background-position: -80px -92px;
}

.mCS-rounded-dark.mCSB_scrollTools .mCSB_buttonLeft {
  background-position: -80px -112px;
}

.mCS-rounded-dark.mCSB_scrollTools .mCSB_buttonRight {
  background-position: -80px -128px;
}

/* theme "rounded-dots", "rounded-dots-dark" */

.mCS-rounded-dots.mCSB_scrollTools_vertical .mCSB_draggerRail,
.mCS-rounded-dots-dark.mCSB_scrollTools_vertical .mCSB_draggerRail {
  width: 4px;
}

.mCS-rounded-dots.mCSB_scrollTools .mCSB_draggerRail,
.mCS-rounded-dots-dark.mCSB_scrollTools .mCSB_draggerRail,
.mCS-rounded-dots.mCSB_scrollTools_horizontal .mCSB_draggerRail,
.mCS-rounded-dots-dark.mCSB_scrollTools_horizontal .mCSB_draggerRail {
  background-color: transparent;
  background-position: center;
}

.mCS-rounded-dots.mCSB_scrollTools .mCSB_draggerRail,
.mCS-rounded-dots-dark.mCSB_scrollTools .mCSB_draggerRail {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-repeat: repeat-y;
  opacity: 0.3;
  filter: 'alpha(opacity=30)';
  -ms-filter: 'alpha(opacity=30)';
}

.mCS-rounded-dots.mCSB_scrollTools_horizontal .mCSB_draggerRail,
.mCS-rounded-dots-dark.mCSB_scrollTools_horizontal .mCSB_draggerRail {
  height: 4px;
  margin: 6px 0;
  background-repeat: repeat-x;
}

.mCS-rounded-dots.mCSB_scrollTools .mCSB_buttonUp {
  background-position: -16px -72px;
}

.mCS-rounded-dots.mCSB_scrollTools .mCSB_buttonDown {
  background-position: -16px -92px;
}

.mCS-rounded-dots.mCSB_scrollTools .mCSB_buttonLeft {
  background-position: -20px -112px;
}

.mCS-rounded-dots.mCSB_scrollTools .mCSB_buttonRight {
  background-position: -20px -128px;
}

/* theme "rounded-dots-dark" */

.mCS-rounded-dots-dark.mCSB_scrollTools .mCSB_draggerRail {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}

.mCS-rounded-dots-dark.mCSB_scrollTools .mCSB_buttonUp {
  background-position: -96px -72px;
}

.mCS-rounded-dots-dark.mCSB_scrollTools .mCSB_buttonDown {
  background-position: -96px -92px;
}

.mCS-rounded-dots-dark.mCSB_scrollTools .mCSB_buttonLeft {
  background-position: -100px -112px;
}

.mCS-rounded-dots-dark.mCSB_scrollTools .mCSB_buttonRight {
  background-position: -100px -128px;
}

/* ---------------------------------------- */

/* theme "3d", "3d-dark", "3d-thick", "3d-thick-dark" */

.mCS-3d.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,
.mCS-3d-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,
.mCS-3d-thick.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,
.mCS-3d-thick-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar {
  background-repeat: repeat-y;
  background-image: -moz-linear-gradient(
    left,
    rgba(255, 255, 255, 0.5) 0%,
    rgba(255, 255, 255, 0) 100%
  );
  background-image: -webkit-gradient(
    linear,
    left top,
    right top,
    color-stop(0%, rgba(255, 255, 255, 0.5)),
    color-stop(100%, rgba(255, 255, 255, 0))
  );
  background-image: -webkit-linear-gradient(
    left,
    rgba(255, 255, 255, 0.5) 0%,
    rgba(255, 255, 255, 0) 100%
  );
  background-image: -o-linear-gradient(
    left,
    rgba(255, 255, 255, 0.5) 0%,
    rgba(255, 255, 255, 0) 100%
  );
  background-image: -ms-linear-gradient(
    left,
    rgba(255, 255, 255, 0.5) 0%,
    rgba(255, 255, 255, 0) 100%
  );
  background-image: linear-gradient(
    to right,
    rgba(255, 255, 255, 0.5) 0%,
    rgba(255, 255, 255, 0) 100%
  );
}

.mCS-3d.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar,
.mCS-3d-dark.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar,
.mCS-3d-thick.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar,
.mCS-3d-thick-dark.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar {
  background-repeat: repeat-x;
  background-image: -moz-linear-gradient(
    top,
    rgba(255, 255, 255, 0.5) 0%,
    rgba(255, 255, 255, 0) 100%
  );
  background-image: -webkit-gradient(
    linear,
    left top,
    left bottom,
    color-stop(0%, rgba(255, 255, 255, 0.5)),
    color-stop(100%, rgba(255, 255, 255, 0))
  );
  background-image: -webkit-linear-gradient(
    top,
    rgba(255, 255, 255, 0.5) 0%,
    rgba(255, 255, 255, 0) 100%
  );
  background-image: -o-linear-gradient(
    top,
    rgba(255, 255, 255, 0.5) 0%,
    rgba(255, 255, 255, 0) 100%
  );
  background-image: -ms-linear-gradient(
    top,
    rgba(255, 255, 255, 0.5) 0%,
    rgba(255, 255, 255, 0) 100%
  );
  background-image: linear-gradient(
    to bottom,
    rgba(255, 255, 255, 0.5) 0%,
    rgba(255, 255, 255, 0) 100%
  );
}

/* theme "3d", "3d-dark" */

.mCS-3d.mCSB_scrollTools_vertical .mCSB_dragger,
.mCS-3d-dark.mCSB_scrollTools_vertical .mCSB_dragger {
  height: 70px;
}

.mCS-3d.mCSB_scrollTools_horizontal .mCSB_dragger,
.mCS-3d-dark.mCSB_scrollTools_horizontal .mCSB_dragger {
  width: 70px;
}

.mCS-3d.mCSB_scrollTools,
.mCS-3d-dark.mCSB_scrollTools {
  opacity: 1;
  filter: 'alpha(opacity=30)';
  -ms-filter: 'alpha(opacity=30)';
}

.mCS-3d.mCSB_scrollTools .mCSB_draggerRail,
.mCS-3d.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,
.mCS-3d-dark.mCSB_scrollTools .mCSB_draggerRail,
.mCS-3d-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar {
  -webkit-border-radius: 16px;
  -moz-border-radius: 16px;
  border-radius: 16px;
}

.mCS-3d.mCSB_scrollTools .mCSB_draggerRail,
.mCS-3d-dark.mCSB_scrollTools .mCSB_draggerRail {
  width: 8px;
  background-color: #000;
  background-color: rgba(0, 0, 0, 0.2);
  box-shadow:
    inset 1px 0 1px rgba(0, 0, 0, 0.5),
    inset -1px 0 1px rgba(255, 255, 255, 0.2);
}

.mCS-3d.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,
.mCS-3d.mCSB_scrollTools .mCSB_dragger:hover .mCSB_dragger_bar,
.mCS-3d.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar,
.mCS-3d.mCSB_scrollTools .mCSB_dragger.mCSB_dragger_onDrag .mCSB_dragger_bar,
.mCS-3d-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,
.mCS-3d-dark.mCSB_scrollTools .mCSB_dragger:hover .mCSB_dragger_bar,
.mCS-3d-dark.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar,
.mCS-3d-dark.mCSB_scrollTools
  .mCSB_dragger.mCSB_dragger_onDrag
  .mCSB_dragger_bar {
  background-color: #555;
}

.mCS-3d.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,
.mCS-3d-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar {
  width: 8px;
}

.mCS-3d.mCSB_scrollTools_horizontal .mCSB_draggerRail,
.mCS-3d-dark.mCSB_scrollTools_horizontal .mCSB_draggerRail {
  width: 100%;
  height: 8px;
  margin: 4px 0;
  box-shadow:
    inset 0 1px 1px rgba(0, 0, 0, 0.5),
    inset 0 -1px 1px rgba(255, 255, 255, 0.2);
}

.mCS-3d.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar,
.mCS-3d-dark.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar {
  width: 100%;
  height: 8px;
  margin: 4px auto;
}

.mCS-3d.mCSB_scrollTools .mCSB_buttonUp {
  background-position: -32px -72px;
}

.mCS-3d.mCSB_scrollTools .mCSB_buttonDown {
  background-position: -32px -92px;
}

.mCS-3d.mCSB_scrollTools .mCSB_buttonLeft {
  background-position: -40px -112px;
}

.mCS-3d.mCSB_scrollTools .mCSB_buttonRight {
  background-position: -40px -128px;
}

/* theme "3d-dark" */

.mCS-3d-dark.mCSB_scrollTools .mCSB_draggerRail {
  background-color: #000;
  background-color: rgba(0, 0, 0, 0.1);
  box-shadow: inset 1px 0 1px rgba(0, 0, 0, 0.1);
}

.mCS-3d-dark.mCSB_scrollTools_horizontal .mCSB_draggerRail {
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.1);
}

.mCS-3d-dark.mCSB_scrollTools .mCSB_buttonUp {
  background-position: -112px -72px;
}

.mCS-3d-dark.mCSB_scrollTools .mCSB_buttonDown {
  background-position: -112px -92px;
}

.mCS-3d-dark.mCSB_scrollTools .mCSB_buttonLeft {
  background-position: -120px -112px;
}

.mCS-3d-dark.mCSB_scrollTools .mCSB_buttonRight {
  background-position: -120px -128px;
}

/* ---------------------------------------- */

/* theme: "3d-thick", "3d-thick-dark" */

.mCS-3d-thick.mCSB_scrollTools,
.mCS-3d-thick-dark.mCSB_scrollTools {
  opacity: 1;
  filter: 'alpha(opacity=30)';
  -ms-filter: 'alpha(opacity=30)';
}

.mCS-3d-thick.mCSB_scrollTools,
.mCS-3d-thick-dark.mCSB_scrollTools,
.mCS-3d-thick.mCSB_scrollTools .mCSB_draggerContainer,
.mCS-3d-thick-dark.mCSB_scrollTools .mCSB_draggerContainer {
  -webkit-border-radius: 7px;
  -moz-border-radius: 7px;
  border-radius: 7px;
}

.mCS-3d-thick.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,
.mCS-3d-thick-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar {
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
}

.mCSB_inside + .mCS-3d-thick.mCSB_scrollTools_vertical,
.mCSB_inside + .mCS-3d-thick-dark.mCSB_scrollTools_vertical {
  right: 1px;
}

.mCS-3d-thick.mCSB_scrollTools_vertical,
.mCS-3d-thick-dark.mCSB_scrollTools_vertical {
  box-shadow:
    inset 1px 0 1px rgba(0, 0, 0, 0.1),
    inset 0 0 14px rgba(0, 0, 0, 0.5);
}

.mCS-3d-thick.mCSB_scrollTools_horizontal,
.mCS-3d-thick-dark.mCSB_scrollTools_horizontal {
  bottom: 1px;
  box-shadow:
    inset 0 1px 1px rgba(0, 0, 0, 0.1),
    inset 0 0 14px rgba(0, 0, 0, 0.5);
}

.mCS-3d-thick.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,
.mCS-3d-thick-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar {
  box-shadow: inset 1px 0 0 rgba(255, 255, 255, 0.4);
  width: 12px;
  margin: 2px;
  position: absolute;
  height: auto;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}

.mCS-3d-thick.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar,
.mCS-3d-thick-dark.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.4);
}

.mCS-3d-thick.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,
.mCS-3d-thick.mCSB_scrollTools .mCSB_dragger:hover .mCSB_dragger_bar,
.mCS-3d-thick.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar,
.mCS-3d-thick.mCSB_scrollTools
  .mCSB_dragger.mCSB_dragger_onDrag
  .mCSB_dragger_bar {
  background-color: #555;
}

.mCS-3d-thick.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar,
.mCS-3d-thick-dark.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar {
  height: 12px;
  width: auto;
}

.mCS-3d-thick.mCSB_scrollTools .mCSB_draggerContainer {
  background-color: #000;
  background-color: rgba(0, 0, 0, 0.05);
  box-shadow: inset 1px 1px 16px rgba(0, 0, 0, 0.1);
}

.mCS-3d-thick.mCSB_scrollTools .mCSB_draggerRail {
  background-color: transparent;
}

.mCS-3d-thick.mCSB_scrollTools .mCSB_buttonUp {
  background-position: -32px -72px;
}

.mCS-3d-thick.mCSB_scrollTools .mCSB_buttonDown {
  background-position: -32px -92px;
}

.mCS-3d-thick.mCSB_scrollTools .mCSB_buttonLeft {
  background-position: -40px -112px;
}

.mCS-3d-thick.mCSB_scrollTools .mCSB_buttonRight {
  background-position: -40px -128px;
}

/* theme: "3d-thick-dark" */

.mCS-3d-thick-dark.mCSB_scrollTools {
  box-shadow: inset 0 0 14px rgba(0, 0, 0, 0.2);
}

.mCS-3d-thick-dark.mCSB_scrollTools_horizontal {
  box-shadow:
    inset 0 1px 1px rgba(0, 0, 0, 0.1),
    inset 0 0 14px rgba(0, 0, 0, 0.2);
}

.mCS-3d-thick-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar {
  box-shadow:
    inset 1px 0 0 rgba(255, 255, 255, 0.4),
    inset -1px 0 0 rgba(0, 0, 0, 0.2);
}

.mCS-3d-thick-dark.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar {
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.4),
    inset 0 -1px 0 rgba(0, 0, 0, 0.2);
}

.mCS-3d-thick-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,
.mCS-3d-thick-dark.mCSB_scrollTools .mCSB_dragger:hover .mCSB_dragger_bar,
.mCS-3d-thick-dark.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar,
.mCS-3d-thick-dark.mCSB_scrollTools
  .mCSB_dragger.mCSB_dragger_onDrag
  .mCSB_dragger_bar {
  background-color: #777;
}

.mCS-3d-thick-dark.mCSB_scrollTools .mCSB_draggerContainer {
  background-color: #fff;
  background-color: rgba(0, 0, 0, 0.05);
  box-shadow: inset 1px 1px 16px rgba(0, 0, 0, 0.1);
}

.mCS-3d-thick-dark.mCSB_scrollTools .mCSB_draggerRail {
  background-color: transparent;
}

.mCS-3d-thick-dark.mCSB_scrollTools .mCSB_buttonUp {
  background-position: -112px -72px;
}

.mCS-3d-thick-dark.mCSB_scrollTools .mCSB_buttonDown {
  background-position: -112px -92px;
}

.mCS-3d-thick-dark.mCSB_scrollTools .mCSB_buttonLeft {
  background-position: -120px -112px;
}

.mCS-3d-thick-dark.mCSB_scrollTools .mCSB_buttonRight {
  background-position: -120px -128px;
}

/* ---------------------------------------- */

/* theme: "minimal", "minimal-dark" */

.mCSB_outside + .mCS-minimal.mCSB_scrollTools_vertical,
.mCSB_outside + .mCS-minimal-dark.mCSB_scrollTools_vertical {
  right: 0;
  margin: 12px 0;
}

.mCustomScrollBox.mCS-minimal + .mCSB_scrollTools.mCSB_scrollTools_horizontal,
.mCustomScrollBox.mCS-minimal
  + .mCSB_scrollTools
  + .mCSB_scrollTools.mCSB_scrollTools_horizontal,
.mCustomScrollBox.mCS-minimal-dark
  + .mCSB_scrollTools.mCSB_scrollTools_horizontal,
.mCustomScrollBox.mCS-minimal-dark
  + .mCSB_scrollTools
  + .mCSB_scrollTools.mCSB_scrollTools_horizontal {
  bottom: 0;
  margin: 0 12px;
}

/* RTL direction/left-side scrollbar */
.mCS-dir-rtl > .mCSB_outside + .mCS-minimal.mCSB_scrollTools_vertical,
.mCS-dir-rtl > .mCSB_outside + .mCS-minimal-dark.mCSB_scrollTools_vertical {
  left: 0;
  right: auto;
}

.mCS-minimal.mCSB_scrollTools .mCSB_draggerRail,
.mCS-minimal-dark.mCSB_scrollTools .mCSB_draggerRail {
  background-color: transparent;
}

.mCS-minimal.mCSB_scrollTools_vertical .mCSB_dragger,
.mCS-minimal-dark.mCSB_scrollTools_vertical .mCSB_dragger {
  height: 50px;
}

.mCS-minimal.mCSB_scrollTools_horizontal .mCSB_dragger,
.mCS-minimal-dark.mCSB_scrollTools_horizontal .mCSB_dragger {
  width: 50px;
}

.mCS-minimal.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar {
  background-color: #fff;
  background-color: rgba(255, 255, 255, 0.2);
  filter: 'alpha(opacity=20)';
  -ms-filter: 'alpha(opacity=20)';
}

.mCS-minimal.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar,
.mCS-minimal.mCSB_scrollTools
  .mCSB_dragger.mCSB_dragger_onDrag
  .mCSB_dragger_bar {
  background-color: #fff;
  background-color: rgba(255, 255, 255, 0.5);
  filter: 'alpha(opacity=50)';
  -ms-filter: 'alpha(opacity=50)';
}

/* theme: "minimal-dark" */

.mCS-minimal-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar {
  background-color: #000;
  background-color: rgba(0, 0, 0, 0.2);
  filter: 'alpha(opacity=20)';
  -ms-filter: 'alpha(opacity=20)';
}

.mCS-minimal-dark.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar,
.mCS-minimal-dark.mCSB_scrollTools
  .mCSB_dragger.mCSB_dragger_onDrag
  .mCSB_dragger_bar {
  background-color: #000;
  background-color: rgba(0, 0, 0, 0.5);
  filter: 'alpha(opacity=50)';
  -ms-filter: 'alpha(opacity=50)';
}

/* ---------------------------------------- */

/* theme "light-3", "dark-3" */

.mCS-light-3.mCSB_scrollTools .mCSB_draggerRail,
.mCS-dark-3.mCSB_scrollTools .mCSB_draggerRail {
  width: 6px;
  background-color: #000;
  background-color: rgba(0, 0, 0, 0.2);
}

.mCS-light-3.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,
.mCS-dark-3.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar {
  width: 6px;
}

.mCS-light-3.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar,
.mCS-dark-3.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar,
.mCS-light-3.mCSB_scrollTools_horizontal .mCSB_draggerRail,
.mCS-dark-3.mCSB_scrollTools_horizontal .mCSB_draggerRail {
  width: 100%;
  height: 6px;
  margin: 5px 0;
}

.mCS-light-3.mCSB_scrollTools_vertical.mCSB_scrollTools_onDrag_expand
  .mCSB_dragger.mCSB_dragger_onDrag_expanded
  + .mCSB_draggerRail,
.mCS-light-3.mCSB_scrollTools_vertical.mCSB_scrollTools_onDrag_expand
  .mCSB_draggerContainer:hover
  .mCSB_draggerRail,
.mCS-dark-3.mCSB_scrollTools_vertical.mCSB_scrollTools_onDrag_expand
  .mCSB_dragger.mCSB_dragger_onDrag_expanded
  + .mCSB_draggerRail,
.mCS-dark-3.mCSB_scrollTools_vertical.mCSB_scrollTools_onDrag_expand
  .mCSB_draggerContainer:hover
  .mCSB_draggerRail {
  width: 12px;
}

.mCS-light-3.mCSB_scrollTools_horizontal.mCSB_scrollTools_onDrag_expand
  .mCSB_dragger.mCSB_dragger_onDrag_expanded
  + .mCSB_draggerRail,
.mCS-light-3.mCSB_scrollTools_horizontal.mCSB_scrollTools_onDrag_expand
  .mCSB_draggerContainer:hover
  .mCSB_draggerRail,
.mCS-dark-3.mCSB_scrollTools_horizontal.mCSB_scrollTools_onDrag_expand
  .mCSB_dragger.mCSB_dragger_onDrag_expanded
  + .mCSB_draggerRail,
.mCS-dark-3.mCSB_scrollTools_horizontal.mCSB_scrollTools_onDrag_expand
  .mCSB_draggerContainer:hover
  .mCSB_draggerRail {
  height: 12px;
  margin: 2px 0;
}

.mCS-light-3.mCSB_scrollTools .mCSB_buttonUp {
  background-position: -32px -72px;
}

.mCS-light-3.mCSB_scrollTools .mCSB_buttonDown {
  background-position: -32px -92px;
}

.mCS-light-3.mCSB_scrollTools .mCSB_buttonLeft {
  background-position: -40px -112px;
}

.mCS-light-3.mCSB_scrollTools .mCSB_buttonRight {
  background-position: -40px -128px;
}

/* theme "dark-3" */

.mCS-dark-3.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar {
  background-color: #000;
  background-color: rgba(0, 0, 0, 0.75);
}

.mCS-dark-3.mCSB_scrollTools .mCSB_dragger:hover .mCSB_dragger_bar {
  background-color: #000;
  background-color: rgba(0, 0, 0, 0.85);
}

.mCS-dark-3.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar,
.mCS-dark-3.mCSB_scrollTools
  .mCSB_dragger.mCSB_dragger_onDrag
  .mCSB_dragger_bar {
  background-color: #000;
  background-color: rgba(0, 0, 0, 0.9);
}

.mCS-dark-3.mCSB_scrollTools .mCSB_draggerRail {
  background-color: #000;
  background-color: rgba(0, 0, 0, 0.1);
}

.mCS-dark-3.mCSB_scrollTools .mCSB_buttonUp {
  background-position: -112px -72px;
}

.mCS-dark-3.mCSB_scrollTools .mCSB_buttonDown {
  background-position: -112px -92px;
}

.mCS-dark-3.mCSB_scrollTools .mCSB_buttonLeft {
  background-position: -120px -112px;
}

.mCS-dark-3.mCSB_scrollTools .mCSB_buttonRight {
  background-position: -120px -128px;
}

/* ---------------------------------------- */

/* theme "inset", "inset-dark", "inset-2", "inset-2-dark", "inset-3", "inset-3-dark" */

.mCS-inset.mCSB_scrollTools .mCSB_draggerRail,
.mCS-inset-dark.mCSB_scrollTools .mCSB_draggerRail,
.mCS-inset-2.mCSB_scrollTools .mCSB_draggerRail,
.mCS-inset-2-dark.mCSB_scrollTools .mCSB_draggerRail,
.mCS-inset-3.mCSB_scrollTools .mCSB_draggerRail,
.mCS-inset-3-dark.mCSB_scrollTools .mCSB_draggerRail {
  width: 12px;
  background-color: #000;
  background-color: rgba(0, 0, 0, 0.2);
}

.mCS-inset.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,
.mCS-inset-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,
.mCS-inset-2.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,
.mCS-inset-2-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,
.mCS-inset-3.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,
.mCS-inset-3-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar {
  width: 6px;
  margin: 3px 5px;
  position: absolute;
  height: auto;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}

.mCS-inset.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar,
.mCS-inset-dark.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar,
.mCS-inset-2.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar,
.mCS-inset-2-dark.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar,
.mCS-inset-3.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar,
.mCS-inset-3-dark.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar {
  height: 6px;
  margin: 5px 3px;
  position: absolute;
  width: auto;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}

.mCS-inset.mCSB_scrollTools_horizontal .mCSB_draggerRail,
.mCS-inset-dark.mCSB_scrollTools_horizontal .mCSB_draggerRail,
.mCS-inset-2.mCSB_scrollTools_horizontal .mCSB_draggerRail,
.mCS-inset-2-dark.mCSB_scrollTools_horizontal .mCSB_draggerRail,
.mCS-inset-3.mCSB_scrollTools_horizontal .mCSB_draggerRail,
.mCS-inset-3-dark.mCSB_scrollTools_horizontal .mCSB_draggerRail {
  width: 100%;
  height: 12px;
  margin: 2px 0;
}

.mCS-inset.mCSB_scrollTools .mCSB_buttonUp,
.mCS-inset-2.mCSB_scrollTools .mCSB_buttonUp,
.mCS-inset-3.mCSB_scrollTools .mCSB_buttonUp {
  background-position: -32px -72px;
}

.mCS-inset.mCSB_scrollTools .mCSB_buttonDown,
.mCS-inset-2.mCSB_scrollTools .mCSB_buttonDown,
.mCS-inset-3.mCSB_scrollTools .mCSB_buttonDown {
  background-position: -32px -92px;
}

.mCS-inset.mCSB_scrollTools .mCSB_buttonLeft,
.mCS-inset-2.mCSB_scrollTools .mCSB_buttonLeft,
.mCS-inset-3.mCSB_scrollTools .mCSB_buttonLeft {
  background-position: -40px -112px;
}

.mCS-inset.mCSB_scrollTools .mCSB_buttonRight,
.mCS-inset-2.mCSB_scrollTools .mCSB_buttonRight,
.mCS-inset-3.mCSB_scrollTools .mCSB_buttonRight {
  background-position: -40px -128px;
}

/* theme "inset-dark", "inset-2-dark", "inset-3-dark" */

.mCS-inset-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,
.mCS-inset-2-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,
.mCS-inset-3-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar {
  background-color: #000;
  background-color: rgba(0, 0, 0, 0.75);
}

.mCS-inset-dark.mCSB_scrollTools .mCSB_dragger:hover .mCSB_dragger_bar,
.mCS-inset-2-dark.mCSB_scrollTools .mCSB_dragger:hover .mCSB_dragger_bar,
.mCS-inset-3-dark.mCSB_scrollTools .mCSB_dragger:hover .mCSB_dragger_bar {
  background-color: #000;
  background-color: rgba(0, 0, 0, 0.85);
}

.mCS-inset-dark.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar,
.mCS-inset-dark.mCSB_scrollTools
  .mCSB_dragger.mCSB_dragger_onDrag
  .mCSB_dragger_bar,
.mCS-inset-2-dark.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar,
.mCS-inset-2-dark.mCSB_scrollTools
  .mCSB_dragger.mCSB_dragger_onDrag
  .mCSB_dragger_bar,
.mCS-inset-3-dark.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar,
.mCS-inset-3-dark.mCSB_scrollTools
  .mCSB_dragger.mCSB_dragger_onDrag
  .mCSB_dragger_bar {
  background-color: #000;
  background-color: rgba(0, 0, 0, 0.9);
}

.mCS-inset-dark.mCSB_scrollTools .mCSB_draggerRail,
.mCS-inset-2-dark.mCSB_scrollTools .mCSB_draggerRail,
.mCS-inset-3-dark.mCSB_scrollTools .mCSB_draggerRail {
  background-color: #000;
  background-color: rgba(0, 0, 0, 0.1);
}

.mCS-inset-dark.mCSB_scrollTools .mCSB_buttonUp,
.mCS-inset-2-dark.mCSB_scrollTools .mCSB_buttonUp,
.mCS-inset-3-dark.mCSB_scrollTools .mCSB_buttonUp {
  background-position: -112px -72px;
}

.mCS-inset-dark.mCSB_scrollTools .mCSB_buttonDown,
.mCS-inset-2-dark.mCSB_scrollTools .mCSB_buttonDown,
.mCS-inset-3-dark.mCSB_scrollTools .mCSB_buttonDown {
  background-position: -112px -92px;
}

.mCS-inset-dark.mCSB_scrollTools .mCSB_buttonLeft,
.mCS-inset-2-dark.mCSB_scrollTools .mCSB_buttonLeft,
.mCS-inset-3-dark.mCSB_scrollTools .mCSB_buttonLeft {
  background-position: -120px -112px;
}

.mCS-inset-dark.mCSB_scrollTools .mCSB_buttonRight,
.mCS-inset-2-dark.mCSB_scrollTools .mCSB_buttonRight,
.mCS-inset-3-dark.mCSB_scrollTools .mCSB_buttonRight {
  background-position: -120px -128px;
}

/* theme "inset-2", "inset-2-dark" */

.mCS-inset-2.mCSB_scrollTools .mCSB_draggerRail,
.mCS-inset-2-dark.mCSB_scrollTools .mCSB_draggerRail {
  background-color: transparent;
  border-width: 1px;
  border-style: solid;
  border-color: #fff;
  border-color: rgba(255, 255, 255, 0.2);
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

.mCS-inset-2-dark.mCSB_scrollTools .mCSB_draggerRail {
  border-color: #000;
  border-color: rgba(0, 0, 0, 0.2);
}

/* theme "inset-3", "inset-3-dark" */

.mCS-inset-3.mCSB_scrollTools .mCSB_draggerRail {
  background-color: #fff;
  background-color: rgba(255, 255, 255, 0.6);
}

.mCS-inset-3-dark.mCSB_scrollTools .mCSB_draggerRail {
  background-color: #000;
  background-color: rgba(0, 0, 0, 0.6);
}

.mCS-inset-3.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar {
  background-color: #000;
  background-color: rgba(0, 0, 0, 0.75);
}

.mCS-inset-3.mCSB_scrollTools .mCSB_dragger:hover .mCSB_dragger_bar {
  background-color: #000;
  background-color: rgba(0, 0, 0, 0.85);
}

.mCS-inset-3.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar,
.mCS-inset-3.mCSB_scrollTools
  .mCSB_dragger.mCSB_dragger_onDrag
  .mCSB_dragger_bar {
  background-color: #000;
  background-color: rgba(0, 0, 0, 0.9);
}

.mCS-inset-3-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar {
  background-color: #fff;
  background-color: rgba(255, 255, 255, 0.75);
}

.mCS-inset-3-dark.mCSB_scrollTools .mCSB_dragger:hover .mCSB_dragger_bar {
  background-color: #fff;
  background-color: rgba(255, 255, 255, 0.85);
}

.mCS-inset-3-dark.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar,
.mCS-inset-3-dark.mCSB_scrollTools
  .mCSB_dragger.mCSB_dragger_onDrag
  .mCSB_dragger_bar {
  background-color: #fff;
  background-color: rgba(255, 255, 255, 0.9);
}

/* ---------------------------------------- */
`, "",{"version":3,"sources":["webpack://./apps/lms/src/css/users/modalScrollBar.css"],"names":[],"mappings":"AAAA;;CAEC;;AAED;;;;;;;;;CASC;;AAED;;;;CAIC;;AAED;EACE,4BAA4B;EAC5B,wBAAwB,EAAE,gCAAgC;AAC5D;AACA;;EAEE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,WAAW;EACX,YAAY;AACd;;AAEA;;;;;CAKC;;AAED;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB,EAAE,0BAA0B;;AAE5B;EACE,sCAAsC;EACtC,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB,EAAE,sCAAsC;;AAExC;EACE,8EAA8E;EAC9E,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,MAAM;EACN,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,YAAY;AACd,EAAE,gCAAgC;;AAElC;;EAEE,sCAAsC;EACtC,WAAW;EACX,OAAO;AACT;;AAEA;EACE,WAAW;AACb,EAAE,oEAAoE;;AAEtE;EACE,2DAA2D;EAC3D,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,SAAS;EACT,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,cAAc;EACd,2BAA2B;EAC3B,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,eAAe;EACf,WAAW;EACX,YAAY,EAAE,2BAA2B;EACzC,UAAU;AACZ;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,cAAc;EACd,2BAA2B;EAC3B,wBAAwB;EACxB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;;;;;;EAOE,WAAW,EAAE,4BAA4B;AAC3C;;AAEA;;;;;;EAME,UAAU,EAAE,4BAA4B;AAC1C;;AAEA;;EAEE,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAS;AACX;;AAEA;;;;;CAKC;;AAED;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB,EAAE,0BAA0B;;AAE5B;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,QAAQ;EACR,SAAS;EACT,OAAO;AACT;;AAEA;;;;EAIE,aAAa;AACf,EAAE,gCAAgC;;AAElC;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,aAAa;AACf;;AAEA;EACE,WAAW,EAAE,0BAA0B;EACvC,YAAY;EACZ,OAAO;AACT;;AAEA;EACE,WAAW;EACX,WAAW;EACX,gBAAgB;AAClB;;AAEA;;;;;;;EAOE,YAAY,EAAE,4BAA4B;EAC1C,gBAAgB;AAClB;;AAEA;;;;;;EAME,WAAW,EAAE,4BAA4B;EACzC,aAAa;AACf;;AAEA;;EAEE,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,QAAQ;AACV;;AAEA;;;;;CAKC;;AAED;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,8BAA8B;EAC9B,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA,qCAAqC;AACrC;;EAEE,SAAS;AACX;;AAEA,qEAAqE;AACrE;;;;;;EAME,QAAQ;AACV;;AAEA,sCAAsC;AACtC;;;EAGE,UAAU;AACZ;;AAEA,4DAA4D;AAC5D;;;;;EAKE,OAAO;AACT;;AAEA;EACE,sCAAsC;EACtC,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,eAAe,EAAE,0BAA0B;EAC3C,cAAc;AAChB;;AAEA,qCAAqC;AACrC;;EAEE,gBAAgB;AAClB;;AAEA;;;;CAIC;;AAED,yBAAyB;AACzB;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;KAkCK;;AAEL;;;;CAIC;;AAED;;;;EAIE;;AAEF,4BAA4B;;AAE5B;EACE,aAAa;EACb,2BAA2B;EAC3B,+BAA+B;AACjC;;AAEA;;EAEE,UAAU;EACV,0BAA0B;EAC1B,8BAA8B;AAChC;;AAEA,4BAA4B;AAC5B;;;;;;;KAOK;;AAEL;EACE,sBAAsB;EACtB,oCAAoC;EACpC,2BAA2B;EAC3B,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;EACtB,2CAA2C;EAC3C,2BAA2B;EAC3B,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;EACtB,2CAA2C;EAC3C,2BAA2B;EAC3B,+BAA+B;AACjC;;AAEA;;EAEE,sBAAsB;EACtB,0CAA0C;EAC1C,2BAA2B;EAC3B,+BAA+B;AACjC;;AAEA;;;;EAIE,yDAAyD;EACzD,4BAA4B;EAC5B,YAAY;EACZ,2BAA2B;EAC3B,+BAA+B;AACjC;;AAEA;EACE,wBAAwB;EACxB;;;;GAIC;AACH;;AAEA;EACE,4BAA4B;EAC5B;;;;GAIC;AACH;;AAEA;EACE,4BAA4B;EAC5B;;;;GAIC;AACH;;AAEA;EACE,4BAA4B;EAC5B;;;;GAIC;AACH;;AAEA;;;;EAIE,aAAa;EACb,2BAA2B;EAC3B,+BAA+B;AACjC;;AAEA;;;;EAIE,YAAY;EACZ,2BAA2B;EAC3B,+BAA+B;AACjC;;AAEA,iBAAiB;;AAEjB;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;EACV,8BAA8B;EAC9B,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;;;;EAIE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,yDAA0E;EAC1E,wBAAwB;EACxB,4BAA4B;AAC9B;;AAEA;EACE,yDAA4E;EAC5E,wBAAwB;EACxB,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;KAEK;;AAEL;;;;;;EAME,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA,kBAAkB;;AAElB;EACE,sBAAsB;EACtB,qCAAqC;AACvC;;AAEA;EACE,sBAAsB;EACtB,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;;;;;;EAME,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA,6CAA6C;;AAE7C,+BAA+B;;AAE/B;;EAEE,UAAU;EACV,sBAAsB;EACtB,0CAA0C;EAC1C,0BAA0B;EAC1B,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;;EAEE,UAAU;EACV,sBAAsB;EACtB,2CAA2C;EAC3C,0BAA0B;EAC1B,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;;;;EAIE,WAAW;EACX,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,2CAA2C;AAC7C;;AAEA;;;;EAIE,sBAAsB;EACtB,0CAA0C;AAC5C;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA,oBAAoB;;AAEpB;EACE,sBAAsB;EACtB,oCAAoC;EACpC,0BAA0B;EAC1B,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,qCAAqC;EACrC,0BAA0B;EAC1B,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,qCAAqC;AACvC;;AAEA;;;;EAIE,sBAAsB;EACtB,oCAAoC;AACtC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA,6CAA6C;;AAE7C,uCAAuC;;AAEvC;;EAEE,UAAU;EACV,sBAAsB;EACtB,0CAA0C;EAC1C,0BAA0B;EAC1B,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;;EAEE,UAAU;EACV,sBAAsB;EACtB,2CAA2C;EAC3C,0BAA0B;EAC1B,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,WAAW;EACX,aAAa;AACf;;AAEA;;EAEE,WAAW;EACX,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,2CAA2C;AAC7C;;AAEA;;;;EAIE,sBAAsB;EACtB,0CAA0C;AAC5C;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA,wBAAwB;;AAExB;EACE,sBAAsB;EACtB,oCAAoC;EACpC,0BAA0B;EAC1B,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,qCAAqC;EACrC,0BAA0B;EAC1B,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,qCAAqC;AACvC;;AAEA;;;;EAIE,sBAAsB;EACtB,oCAAoC;AACtC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA,6CAA6C;;AAE7C,qCAAqC;;AAErC;EACE,sBAAsB;EACtB,0CAA0C;AAC5C;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE,WAAW;AACb;;AAEA;;EAEE,WAAW;EACX,WAAW;EACX,gBAAgB;AAClB;;AAEA,sBAAsB;;AAEtB;EACE,sBAAsB;EACtB,qCAAqC;AACvC;;AAEA;EACE,sBAAsB;EACtB,qCAAqC;AACvC;;AAEA;EACE,sBAAsB;EACtB,qCAAqC;AACvC;;AAEA;;;;EAIE,sBAAsB;EACtB,oCAAoC;AACtC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA,6CAA6C;;AAE7C,yEAAyE;;AAEzE;EACE,sBAAsB;EACtB,2CAA2C;AAC7C;;AAEA;;;;EAIE,YAAY;AACd;;AAEA;;;;EAIE,WAAW;EACX,aAAa;AACf;;AAEA;;;;EAIE,WAAW;AACb;;AAEA;;;;;;EAME,YAAY;EACZ,aAAa;AACf;;AAEA;;;;;;;;;;;;;;EAcE,WAAW,EAAE,4BAA4B;EACzC,YAAY;EACZ,cAAc;AAChB;;AAEA;;;;;;;;;;;;EAYE,UAAU,EAAE,4BAA4B;AAC1C;;AAEA;;;;;;;;;;;;;;EAcE,YAAY,EAAE,4BAA4B;EAC1C,WAAW;EACX,cAAc;AAChB;;AAEA;;;;;;;;;;;;EAYE,WAAW,EAAE,4BAA4B;EACzC,aAAa;AACf;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,8CAA8C;;AAE9C;;EAEE,sBAAsB;EACtB,qCAAqC;AACvC;;AAEA;EACE,sBAAsB;EACtB,qCAAqC;AACvC;;AAEA;;EAEE,sBAAsB;EACtB,qCAAqC;AACvC;;AAEA;;;;;;;;EAQE,sBAAsB;EACtB,oCAAoC;AACtC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA,8CAA8C;;AAE9C;;EAEE,UAAU;AACZ;;AAEA;;;;EAIE,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;;EAEE,yDAAmM;EACnM,2BAA2B;EAC3B,YAAY;EACZ,2BAA2B;EAC3B,+BAA+B;AACjC;;AAEA;;EAEE,WAAW;EACX,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA,8BAA8B;;AAE9B;EACE,yDAAuL;AACzL;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA,6CAA6C;;AAE7C,uDAAuD;;AAEvD;;;;EAIE,2BAA2B;EAC3B;;;;GAIC;EACD;;;;;;GAMC;EACD;;;;GAIC;EACD;;;;GAIC;EACD;;;;GAIC;EACD;;;;GAIC;AACH;;AAEA;;;;EAIE,2BAA2B;EAC3B;;;;GAIC;EACD;;;;;;GAMC;EACD;;;;GAIC;EACD;;;;GAIC;EACD;;;;GAIC;EACD;;;;GAIC;AACH;;AAEA,0BAA0B;;AAE1B;;EAEE,YAAY;AACd;;AAEA;;EAEE,WAAW;AACb;;AAEA;;EAEE,UAAU;EACV,2BAA2B;EAC3B,+BAA+B;AACjC;;AAEA;;;;EAIE,2BAA2B;EAC3B,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;;EAEE,UAAU;EACV,sBAAsB;EACtB,oCAAoC;EACpC;;6CAE2C;AAC7C;;AAEA;;;;;;;;;;EAUE,sBAAsB;AACxB;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE,WAAW;EACX,WAAW;EACX,aAAa;EACb;;6CAE2C;AAC7C;;AAEA;;EAEE,WAAW;EACX,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA,oBAAoB;;AAEpB;EACE,sBAAsB;EACtB,oCAAoC;EACpC,8CAA8C;AAChD;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA,6CAA6C;;AAE7C,uCAAuC;;AAEvC;;EAEE,UAAU;EACV,2BAA2B;EAC3B,+BAA+B;AACjC;;AAEA;;;;EAIE,0BAA0B;EAC1B,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;;EAEE,0BAA0B;EAC1B,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE;;qCAEmC;AACrC;;AAEA;;EAEE,WAAW;EACX;;qCAEmC;AACrC;;AAEA;;EAEE,kDAAkD;EAClD,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,MAAM;EACN,SAAS;EACT,OAAO;EACP,QAAQ;AACV;;AAEA;;EAEE,kDAAkD;AACpD;;AAEA;;;;;;EAME,sBAAsB;AACxB;;AAEA;;EAEE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,qCAAqC;EACrC,iDAAiD;AACnD;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA,2BAA2B;;AAE3B;EACE,6CAA6C;AAC/C;;AAEA;EACE;;qCAEmC;AACrC;;AAEA;EACE;;qCAEmC;AACrC;;AAEA;EACE;;qCAEmC;AACrC;;AAEA;;;;;;EAME,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,qCAAqC;EACrC,iDAAiD;AACnD;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA,6CAA6C;;AAE7C,qCAAqC;;AAErC;;EAEE,QAAQ;EACR,cAAc;AAChB;;AAEA;;;;;;;;;EASE,SAAS;EACT,cAAc;AAChB;;AAEA,sCAAsC;AACtC;;EAEE,OAAO;EACP,WAAW;AACb;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;;EAEE,YAAY;AACd;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,0CAA0C;EAC1C,2BAA2B;EAC3B,+BAA+B;AACjC;;AAEA;;;;EAIE,sBAAsB;EACtB,0CAA0C;EAC1C,2BAA2B;EAC3B,+BAA+B;AACjC;;AAEA,0BAA0B;;AAE1B;EACE,sBAAsB;EACtB,oCAAoC;EACpC,2BAA2B;EAC3B,+BAA+B;AACjC;;AAEA;;;;EAIE,sBAAsB;EACtB,oCAAoC;EACpC,2BAA2B;EAC3B,+BAA+B;AACjC;;AAEA,6CAA6C;;AAE7C,8BAA8B;;AAE9B;;EAEE,UAAU;EACV,sBAAsB;EACtB,oCAAoC;AACtC;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;;;EAIE,WAAW;EACX,WAAW;EACX,aAAa;AACf;;AAEA;;;;;;;;;;;;EAYE,WAAW;AACb;;AAEA;;;;;;;;;;;;EAYE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA,mBAAmB;;AAEnB;EACE,sBAAsB;EACtB,qCAAqC;AACvC;;AAEA;EACE,sBAAsB;EACtB,qCAAqC;AACvC;;AAEA;;;;EAIE,sBAAsB;EACtB,oCAAoC;AACtC;;AAEA;EACE,sBAAsB;EACtB,oCAAoC;AACtC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA,6CAA6C;;AAE7C,sFAAsF;;AAEtF;;;;;;EAME,WAAW;EACX,sBAAsB;EACtB,oCAAoC;AACtC;;AAEA;;;;;;EAME,UAAU;EACV,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,MAAM;EACN,SAAS;EACT,OAAO;EACP,QAAQ;AACV;;AAEA;;;;;;EAME,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,MAAM;EACN,SAAS;EACT,OAAO;EACP,QAAQ;AACV;;AAEA;;;;;;EAME,WAAW;EACX,YAAY;EACZ,aAAa;AACf;;AAEA;;;EAGE,gCAAgC;AAClC;;AAEA;;;EAGE,gCAAgC;AAClC;;AAEA;;;EAGE,iCAAiC;AACnC;;AAEA;;;EAGE,iCAAiC;AACnC;;AAEA,uDAAuD;;AAEvD;;;EAGE,sBAAsB;EACtB,qCAAqC;AACvC;;AAEA;;;EAGE,sBAAsB;EACtB,qCAAqC;AACvC;;AAEA;;;;;;;;;;;;EAYE,sBAAsB;EACtB,oCAAoC;AACtC;;AAEA;;;EAGE,sBAAsB;EACtB,oCAAoC;AACtC;;AAEA;;;EAGE,iCAAiC;AACnC;;AAEA;;;EAGE,iCAAiC;AACnC;;AAEA;;;EAGE,kCAAkC;AACpC;;AAEA;;;EAGE,kCAAkC;AACpC;;AAEA,oCAAoC;;AAEpC;;EAEE,6BAA6B;EAC7B,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,sCAAsC;EACtC,8BAA8B;EAC9B,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA,oCAAoC;;AAEpC;EACE,sBAAsB;EACtB,0CAA0C;AAC5C;;AAEA;EACE,sBAAsB;EACtB,oCAAoC;AACtC;;AAEA;EACE,sBAAsB;EACtB,qCAAqC;AACvC;;AAEA;EACE,sBAAsB;EACtB,qCAAqC;AACvC;;AAEA;;;;EAIE,sBAAsB;EACtB,oCAAoC;AACtC;;AAEA;EACE,sBAAsB;EACtB,2CAA2C;AAC7C;;AAEA;EACE,sBAAsB;EACtB,2CAA2C;AAC7C;;AAEA;;;;EAIE,sBAAsB;EACtB,0CAA0C;AAC5C;;AAEA,6CAA6C","sourcesContent":["/*\n== malihu jquery custom scrollbar plugin ==\n*/\n\n/*\nCONTENTS: \n\t1. BASIC STYLE - Plugin's basic/essential CSS properties (normally, should not be edited). \n\t2. VERTICAL SCROLLBAR - Positioning and dimensions of vertical scrollbar. \n\t3. HORIZONTAL SCROLLBAR - Positioning and dimensions of horizontal scrollbar.\n\t4. VERTICAL AND HORIZONTAL SCROLLBARS - Positioning and dimensions of 2-axis scrollbars. \n\t5. TRANSITIONS - CSS3 transitions for hover events, auto-expanded and auto-hidden scrollbars. \n\t6. SCROLLBAR COLORS, OPACITY AND BACKGROUNDS \n\t\t6.1 THEMES - Scrollbar colors, opacity, dimensions, backgrounds etc. via ready-to-use themes.\n*/\n\n/* \n------------------------------------------------------------------------------------------------------------------------\n1. BASIC STYLE  \n------------------------------------------------------------------------------------------------------------------------\n*/\n\n.mCustomScrollbar {\n  -ms-touch-action: pinch-zoom;\n  touch-action: pinch-zoom; /* direct pointer events to js */\n}\n.mCustomScrollbar.mCS_no_scrollbar,\n.mCustomScrollbar.mCS_touch_action {\n  -ms-touch-action: auto;\n  touch-action: auto;\n}\n\n.mCustomScrollBox {\n  /* contains plugin's markup */\n  position: relative;\n  overflow: hidden;\n  height: 100%;\n  max-width: 100%;\n  outline: none;\n  direction: ltr;\n}\n\n.mCSB_container {\n  /* contains the original content */\n  overflow: hidden;\n  width: auto;\n  height: auto;\n}\n\n/* \n------------------------------------------------------------------------------------------------------------------------\n2. VERTICAL SCROLLBAR \ny-axis\n------------------------------------------------------------------------------------------------------------------------\n*/\n\n.mCSB_inside > .mCSB_container {\n  margin-right: 30px;\n}\n\n.mCSB_container.mCS_no_scrollbar_y.mCS_y_hidden {\n  margin-right: 0;\n} /* non-visible scrollbar */\n\n.mCS-dir-rtl > .mCSB_inside > .mCSB_container {\n  /* RTL direction/left-side scrollbar */\n  margin-right: 0;\n  margin-left: 30px;\n}\n\n.mCS-dir-rtl > .mCSB_inside > .mCSB_container.mCS_no_scrollbar_y.mCS_y_hidden {\n  margin-left: 0;\n} /* RTL direction/left-side scrollbar */\n\n.mCSB_scrollTools {\n  /* contains scrollbar markup (draggable element, dragger rail, buttons etc.) */\n  position: absolute;\n  width: 16px;\n  height: auto;\n  left: auto;\n  top: 0;\n  right: 0;\n  bottom: 0;\n}\n\n.mCSB_outside + .mCSB_scrollTools {\n  right: -26px;\n} /* scrollbar position: outside */\n\n.mCS-dir-rtl > .mCSB_inside > .mCSB_scrollTools,\n.mCS-dir-rtl > .mCSB_outside + .mCSB_scrollTools {\n  /* RTL direction/left-side scrollbar */\n  right: auto;\n  left: 0;\n}\n\n.mCS-dir-rtl > .mCSB_outside + .mCSB_scrollTools {\n  left: -26px;\n} /* RTL direction/left-side scrollbar (scrollbar position: outside) */\n\n.mCSB_scrollTools .mCSB_draggerContainer {\n  /* contains the draggable element and dragger rail markup */\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  height: auto;\n}\n\n.mCSB_scrollTools a + .mCSB_draggerContainer {\n  margin: 20px 0;\n}\n\n.mCSB_scrollTools .mCSB_draggerRail {\n  width: 2px;\n  height: 100%;\n  margin: 0 auto;\n  -webkit-border-radius: 16px;\n  -moz-border-radius: 16px;\n  border-radius: 16px;\n}\n\n.mCSB_scrollTools .mCSB_dragger {\n  /* the draggable element */\n  cursor: pointer;\n  width: 100%;\n  height: 30px; /* minimum dragger height */\n  z-index: 1;\n}\n\n.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar {\n  /* the dragger element */\n  position: relative;\n  width: 4px;\n  height: 100%;\n  margin: 0 auto;\n  -webkit-border-radius: 16px;\n  -moz-border-radius: 16px;\n  border-radius: 16px;\n  text-align: center;\n}\n\n.mCSB_scrollTools_vertical.mCSB_scrollTools_onDrag_expand\n  .mCSB_dragger.mCSB_dragger_onDrag_expanded\n  .mCSB_dragger_bar,\n.mCSB_scrollTools_vertical.mCSB_scrollTools_onDrag_expand\n  .mCSB_draggerContainer:hover\n  .mCSB_dragger\n  .mCSB_dragger_bar {\n  width: 12px; /* auto-expanded scrollbar */\n}\n\n.mCSB_scrollTools_vertical.mCSB_scrollTools_onDrag_expand\n  .mCSB_dragger.mCSB_dragger_onDrag_expanded\n  + .mCSB_draggerRail,\n.mCSB_scrollTools_vertical.mCSB_scrollTools_onDrag_expand\n  .mCSB_draggerContainer:hover\n  .mCSB_draggerRail {\n  width: 8px; /* auto-expanded scrollbar */\n}\n\n.mCSB_scrollTools .mCSB_buttonUp,\n.mCSB_scrollTools .mCSB_buttonDown {\n  display: block;\n  position: absolute;\n  height: 20px;\n  width: 100%;\n  overflow: hidden;\n  margin: 0 auto;\n  cursor: pointer;\n}\n\n.mCSB_scrollTools .mCSB_buttonDown {\n  bottom: 0;\n}\n\n/* \n------------------------------------------------------------------------------------------------------------------------\n3. HORIZONTAL SCROLLBAR \nx-axis\n------------------------------------------------------------------------------------------------------------------------\n*/\n\n.mCSB_horizontal.mCSB_inside > .mCSB_container {\n  margin-right: 0;\n  margin-bottom: 30px;\n}\n\n.mCSB_horizontal.mCSB_outside > .mCSB_container {\n  min-height: 100%;\n}\n\n.mCSB_horizontal > .mCSB_container.mCS_no_scrollbar_x.mCS_x_hidden {\n  margin-bottom: 0;\n} /* non-visible scrollbar */\n\n.mCSB_scrollTools.mCSB_scrollTools_horizontal {\n  width: auto;\n  height: 16px;\n  top: auto;\n  right: 0;\n  bottom: 0;\n  left: 0;\n}\n\n.mCustomScrollBox + .mCSB_scrollTools.mCSB_scrollTools_horizontal,\n.mCustomScrollBox\n  + .mCSB_scrollTools\n  + .mCSB_scrollTools.mCSB_scrollTools_horizontal {\n  bottom: -26px;\n} /* scrollbar position: outside */\n\n.mCSB_scrollTools.mCSB_scrollTools_horizontal a + .mCSB_draggerContainer {\n  margin: 0 20px;\n}\n\n.mCSB_scrollTools.mCSB_scrollTools_horizontal .mCSB_draggerRail {\n  width: 100%;\n  height: 2px;\n  margin: 7px 0;\n}\n\n.mCSB_scrollTools.mCSB_scrollTools_horizontal .mCSB_dragger {\n  width: 30px; /* minimum dragger width */\n  height: 100%;\n  left: 0;\n}\n\n.mCSB_scrollTools.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar {\n  width: 100%;\n  height: 4px;\n  margin: 6px auto;\n}\n\n.mCSB_scrollTools_horizontal.mCSB_scrollTools_onDrag_expand\n  .mCSB_dragger.mCSB_dragger_onDrag_expanded\n  .mCSB_dragger_bar,\n.mCSB_scrollTools_horizontal.mCSB_scrollTools_onDrag_expand\n  .mCSB_draggerContainer:hover\n  .mCSB_dragger\n  .mCSB_dragger_bar {\n  height: 12px; /* auto-expanded scrollbar */\n  margin: 2px auto;\n}\n\n.mCSB_scrollTools_horizontal.mCSB_scrollTools_onDrag_expand\n  .mCSB_dragger.mCSB_dragger_onDrag_expanded\n  + .mCSB_draggerRail,\n.mCSB_scrollTools_horizontal.mCSB_scrollTools_onDrag_expand\n  .mCSB_draggerContainer:hover\n  .mCSB_draggerRail {\n  height: 8px; /* auto-expanded scrollbar */\n  margin: 4px 0;\n}\n\n.mCSB_scrollTools.mCSB_scrollTools_horizontal .mCSB_buttonLeft,\n.mCSB_scrollTools.mCSB_scrollTools_horizontal .mCSB_buttonRight {\n  display: block;\n  position: absolute;\n  width: 20px;\n  height: 100%;\n  overflow: hidden;\n  margin: 0 auto;\n  cursor: pointer;\n}\n\n.mCSB_scrollTools.mCSB_scrollTools_horizontal .mCSB_buttonLeft {\n  left: 0;\n}\n\n.mCSB_scrollTools.mCSB_scrollTools_horizontal .mCSB_buttonRight {\n  right: 0;\n}\n\n/* \n------------------------------------------------------------------------------------------------------------------------\n4. VERTICAL AND HORIZONTAL SCROLLBARS \nyx-axis \n------------------------------------------------------------------------------------------------------------------------\n*/\n\n.mCSB_container_wrapper {\n  position: absolute;\n  height: auto;\n  width: auto;\n  overflow: hidden;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  margin-right: 30px;\n  margin-bottom: 30px;\n}\n\n.mCSB_container_wrapper > .mCSB_container {\n  padding-right: 30px;\n  padding-bottom: 30px;\n  -webkit-box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n}\n\n.mCSB_vertical_horizontal > .mCSB_scrollTools.mCSB_scrollTools_vertical {\n  bottom: 20px;\n}\n\n.mCSB_vertical_horizontal > .mCSB_scrollTools.mCSB_scrollTools_horizontal {\n  right: 20px;\n}\n\n/* non-visible horizontal scrollbar */\n.mCSB_container_wrapper.mCS_no_scrollbar_x.mCS_x_hidden\n  + .mCSB_scrollTools.mCSB_scrollTools_vertical {\n  bottom: 0;\n}\n\n/* non-visible vertical scrollbar/RTL direction/left-side scrollbar */\n.mCSB_container_wrapper.mCS_no_scrollbar_y.mCS_y_hidden\n  + .mCSB_scrollTools\n  ~ .mCSB_scrollTools.mCSB_scrollTools_horizontal,\n.mCS-dir-rtl\n  > .mCustomScrollBox.mCSB_vertical_horizontal.mCSB_inside\n  > .mCSB_scrollTools.mCSB_scrollTools_horizontal {\n  right: 0;\n}\n\n/* RTL direction/left-side scrollbar */\n.mCS-dir-rtl\n  > .mCustomScrollBox.mCSB_vertical_horizontal.mCSB_inside\n  > .mCSB_scrollTools.mCSB_scrollTools_horizontal {\n  left: 20px;\n}\n\n/* non-visible scrollbar/RTL direction/left-side scrollbar */\n.mCS-dir-rtl\n  > .mCustomScrollBox.mCSB_vertical_horizontal.mCSB_inside\n  > .mCSB_container_wrapper.mCS_no_scrollbar_y.mCS_y_hidden\n  + .mCSB_scrollTools\n  ~ .mCSB_scrollTools.mCSB_scrollTools_horizontal {\n  left: 0;\n}\n\n.mCS-dir-rtl > .mCSB_inside > .mCSB_container_wrapper {\n  /* RTL direction/left-side scrollbar */\n  margin-right: 0;\n  margin-left: 30px;\n}\n\n.mCSB_container_wrapper.mCS_no_scrollbar_y.mCS_y_hidden > .mCSB_container {\n  padding-right: 0;\n}\n\n.mCSB_container_wrapper.mCS_no_scrollbar_x.mCS_x_hidden > .mCSB_container {\n  padding-bottom: 0;\n}\n\n.mCustomScrollBox.mCSB_vertical_horizontal.mCSB_inside\n  > .mCSB_container_wrapper.mCS_no_scrollbar_y.mCS_y_hidden {\n  margin-right: 0; /* non-visible scrollbar */\n  margin-left: 0;\n}\n\n/* non-visible horizontal scrollbar */\n.mCustomScrollBox.mCSB_vertical_horizontal.mCSB_inside\n  > .mCSB_container_wrapper.mCS_no_scrollbar_x.mCS_x_hidden {\n  margin-bottom: 0;\n}\n\n/* \n------------------------------------------------------------------------------------------------------------------------\n5. TRANSITIONS  \n------------------------------------------------------------------------------------------------------------------------\n*/\n\n/* Kill all transitions */\n/*\n\t.mCSB_scrollTools, \n\t.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar, \n\t.mCSB_scrollTools .mCSB_buttonUp,\n\t.mCSB_scrollTools .mCSB_buttonDown,\n\t.mCSB_scrollTools .mCSB_buttonLeft,\n\t.mCSB_scrollTools .mCSB_buttonRight{\n\t\t-webkit-transition: opacity .2s ease-in-out, background-color .2s ease-in-out;\n\t\t-moz-transition: opacity .2s ease-in-out, background-color .2s ease-in-out;\n\t\t-o-transition: opacity .2s ease-in-out, background-color .2s ease-in-out;\n\t\ttransition: opacity .2s ease-in-out, background-color .2s ease-in-out;\n\t}\n\t\n\t.mCSB_scrollTools_vertical.mCSB_scrollTools_onDrag_expand .mCSB_dragger_bar, \n\t.mCSB_scrollTools_vertical.mCSB_scrollTools_onDrag_expand .mCSB_draggerRail, \n\t.mCSB_scrollTools_horizontal.mCSB_scrollTools_onDrag_expand .mCSB_dragger_bar, \n\t.mCSB_scrollTools_horizontal.mCSB_scrollTools_onDrag_expand .mCSB_draggerRail{\n\t\t-webkit-transition: width .2s ease-out .2s, height .2s ease-out .2s, \n\t\t\t\t\tmargin-left .2s ease-out .2s, margin-right .2s ease-out .2s, \n\t\t\t\t\tmargin-top .2s ease-out .2s, margin-bottom .2s ease-out .2s,\n\t\t\t\t\topacity .2s ease-in-out, background-color .2s ease-in-out; \n\t\t-moz-transition: width .2s ease-out .2s, height .2s ease-out .2s, \n\t\t\t\t\tmargin-left .2s ease-out .2s, margin-right .2s ease-out .2s, \n\t\t\t\t\tmargin-top .2s ease-out .2s, margin-bottom .2s ease-out .2s,\n\t\t\t\t\topacity .2s ease-in-out, background-color .2s ease-in-out; \n\t\t-o-transition: width .2s ease-out .2s, height .2s ease-out .2s, \n\t\t\t\t\tmargin-left .2s ease-out .2s, margin-right .2s ease-out .2s, \n\t\t\t\t\tmargin-top .2s ease-out .2s, margin-bottom .2s ease-out .2s,\n\t\t\t\t\topacity .2s ease-in-out, background-color .2s ease-in-out; \n\t\ttransition: width .2s ease-out .2s, height .2s ease-out .2s, \n\t\t\t\t\tmargin-left .2s ease-out .2s, margin-right .2s ease-out .2s, \n\t\t\t\t\tmargin-top .2s ease-out .2s, margin-bottom .2s ease-out .2s,\n\t\t\t\t\topacity .2s ease-in-out, background-color .2s ease-in-out; \n\t}\n    */\n\n/* \n------------------------------------------------------------------------------------------------------------------------\n6. SCROLLBAR COLORS, OPACITY AND BACKGROUNDS  \n------------------------------------------------------------------------------------------------------------------------\n*/\n\n/* \n\t----------------------------------------\n\t6.1 THEMES \n\t----------------------------------------\n\t*/\n\n/* default theme (\"light\") */\n\n.mCSB_scrollTools {\n  opacity: 0.75;\n  filter: 'alpha(opacity=75)';\n  -ms-filter: 'alpha(opacity=75)';\n}\n\n.mCS-autoHide > .mCustomScrollBox > .mCSB_scrollTools,\n.mCS-autoHide > .mCustomScrollBox ~ .mCSB_scrollTools {\n  opacity: 0;\n  filter: 'alpha(opacity=0)';\n  -ms-filter: 'alpha(opacity=0)';\n}\n\n/* Get rid of drag effects */\n/*\n\t.mCustomScrollbar > .mCustomScrollBox > .mCSB_scrollTools.mCSB_scrollTools_onDrag,\n\t.mCustomScrollbar > .mCustomScrollBox ~ .mCSB_scrollTools.mCSB_scrollTools_onDrag,\n\t.mCustomScrollBox:hover > .mCSB_scrollTools,\n\t.mCustomScrollBox:hover ~ .mCSB_scrollTools,\n\t.mCS-autoHide:hover > .mCustomScrollBox > .mCSB_scrollTools,\n\t.mCS-autoHide:hover > .mCustomScrollBox ~ .mCSB_scrollTools{ opacity: 1; filter: \"alpha(opacity=100)\"; -ms-filter: \"alpha(opacity=100)\"; }\n    */\n\n.mCSB_scrollTools .mCSB_draggerRail {\n  background-color: #000;\n  background-color: rgba(0, 0, 0, 0.4);\n  filter: 'alpha(opacity=40)';\n  -ms-filter: 'alpha(opacity=40)';\n}\n\n.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar {\n  background-color: #fff;\n  background-color: rgba(255, 255, 255, 0.75);\n  filter: 'alpha(opacity=75)';\n  -ms-filter: 'alpha(opacity=75)';\n}\n\n.mCSB_scrollTools .mCSB_dragger:hover .mCSB_dragger_bar {\n  background-color: #fff;\n  background-color: rgba(255, 255, 255, 0.85);\n  filter: 'alpha(opacity=85)';\n  -ms-filter: 'alpha(opacity=85)';\n}\n\n.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar,\n.mCSB_scrollTools .mCSB_dragger.mCSB_dragger_onDrag .mCSB_dragger_bar {\n  background-color: #fff;\n  background-color: rgba(255, 255, 255, 0.9);\n  filter: 'alpha(opacity=90)';\n  -ms-filter: 'alpha(opacity=90)';\n}\n\n.mCSB_scrollTools .mCSB_buttonUp,\n.mCSB_scrollTools .mCSB_buttonDown,\n.mCSB_scrollTools .mCSB_buttonLeft,\n.mCSB_scrollTools .mCSB_buttonRight {\n  /* background-image: url(mCSB_buttons.png); css sprites */\n  background-repeat: no-repeat;\n  opacity: 0.4;\n  filter: 'alpha(opacity=40)';\n  -ms-filter: 'alpha(opacity=40)';\n}\n\n.mCSB_scrollTools .mCSB_buttonUp {\n  background-position: 0 0;\n  /* \n\t\tsprites locations \n\t\tlight: 0 0, -16px 0, -32px 0, -48px 0, 0 -72px, -16px -72px, -32px -72px\n\t\tdark: -80px 0, -96px 0, -112px 0, -128px 0, -80px -72px, -96px -72px, -112px -72px\n\t\t*/\n}\n\n.mCSB_scrollTools .mCSB_buttonDown {\n  background-position: 0 -20px;\n  /* \n\t\tsprites locations\n\t\tlight: 0 -20px, -16px -20px, -32px -20px, -48px -20px, 0 -92px, -16px -92px, -32px -92px\n\t\tdark: -80px -20px, -96px -20px, -112px -20px, -128px -20px, -80px -92px, -96px -92px, -112 -92px\n\t\t*/\n}\n\n.mCSB_scrollTools .mCSB_buttonLeft {\n  background-position: 0 -40px;\n  /* \n\t\tsprites locations \n\t\tlight: 0 -40px, -20px -40px, -40px -40px, -60px -40px, 0 -112px, -20px -112px, -40px -112px\n\t\tdark: -80px -40px, -100px -40px, -120px -40px, -140px -40px, -80px -112px, -100px -112px, -120px -112px\n\t\t*/\n}\n\n.mCSB_scrollTools .mCSB_buttonRight {\n  background-position: 0 -56px;\n  /* \n\t\tsprites locations \n\t\tlight: 0 -56px, -20px -56px, -40px -56px, -60px -56px, 0 -128px, -20px -128px, -40px -128px\n\t\tdark: -80px -56px, -100px -56px, -120px -56px, -140px -56px, -80px -128px, -100px -128px, -120px -128px\n\t\t*/\n}\n\n.mCSB_scrollTools .mCSB_buttonUp:hover,\n.mCSB_scrollTools .mCSB_buttonDown:hover,\n.mCSB_scrollTools .mCSB_buttonLeft:hover,\n.mCSB_scrollTools .mCSB_buttonRight:hover {\n  opacity: 0.75;\n  filter: 'alpha(opacity=75)';\n  -ms-filter: 'alpha(opacity=75)';\n}\n\n.mCSB_scrollTools .mCSB_buttonUp:active,\n.mCSB_scrollTools .mCSB_buttonDown:active,\n.mCSB_scrollTools .mCSB_buttonLeft:active,\n.mCSB_scrollTools .mCSB_buttonRight:active {\n  opacity: 0.9;\n  filter: 'alpha(opacity=90)';\n  -ms-filter: 'alpha(opacity=90)';\n}\n\n/* theme: \"bai\" */\n\n.mCS-bai .mCSB_draggerContainer {\n  background-color: #a1a097;\n}\n\n.mCS-bai.mCSB_scrollTools .mCSB_draggerRail {\n  background-color: #a1a097;\n}\n\n.mCS-bai .mCSB_scrollTools {\n  width: 14px;\n}\n\n.mCS-bai .mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar {\n  width: 8px;\n  -webkit-border-radius: initial;\n  -moz-border-radius: initial;\n  border-radius: initial;\n}\n\n.mCS-bai.mCSB_scrollTools .mCSB_buttonUp,\n.mCS-bai.mCSB_scrollTools .mCSB_buttonDown,\n.mCS-bai.mCSB_scrollTools .mCSB_buttonLeft,\n.mCS-bai.mCSB_scrollTools .mCSB_buttonRight {\n  background-color: #a1a097;\n  opacity: initial;\n}\n\n.mCS-bai.mCSB_scrollTools .mCSB_buttonUp {\n  background-image: url('../../assets/images/icons/scroll-bar-up-arrow.svg');\n  background-size: 8px 8px;\n  background-position: 3px 4px;\n}\n\n.mCS-bai.mCSB_scrollTools .mCSB_buttonDown {\n  background-image: url('../../assets/images/icons/scroll-bar-down-arrow.svg');\n  background-size: 8px 8px;\n  background-position: 3px 8px;\n}\n\n.mCS-bai .mCSB_container_wrapper > .mCSB_container {\n  padding-right: 0;\n}\n\n.MCS-bai .mCSB_scrollTools {\n  opacity: initial;\n}\n\n.mCS-bai .mCSB_container_wrapper {\n  margin-right: 22px;\n}\n\n.mCS-bai.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar {\n  background-color: #e5e5e5;\n}\n\n/*\n\t.mCS-bai.mCSB_scrollTools .mCSB_dragger:hover .mCSB_dragger_bar{ background-color: rgba(0,0,0,0.85); }\n    */\n\n.mCS-bai.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar,\n    /*\n\t.mCS-bai.mCSB_scrollTools .mCSB_dragger.mCSB_dragger_onDrag .mCSB_dragger_bar{ background-color: rgba(0,0,0,0.9); }\n    */\n\n\t.mCS-bai.mCSB_scrollTools .mCSB_buttonLeft {\n  background-position: -80px -40px;\n}\n\n.mCS-bai.mCSB_scrollTools .mCSB_buttonRight {\n  background-position: -80px -56px;\n}\n\n/* theme: \"dark\" */\n\n.mCS-dark.mCSB_scrollTools .mCSB_draggerRail {\n  background-color: #000;\n  background-color: rgba(0, 0, 0, 0.15);\n}\n\n.mCS-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar {\n  background-color: #000;\n  background-color: rgba(0, 0, 0, 0.75);\n}\n\n.mCS-dark.mCSB_scrollTools .mCSB_dragger:hover .mCSB_dragger_bar {\n  background-color: rgba(0, 0, 0, 0.85);\n}\n\n.mCS-dark.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar,\n    /*\n\t.mCS-dark.mCSB_scrollTools .mCSB_dragger.mCSB_dragger_onDrag .mCSB_dragger_bar{ background-color: rgba(0,0,0,0.9); }\n    */\n\n\t.mCS-dark.mCSB_scrollTools .mCSB_buttonUp {\n  background-position: -80px 0;\n}\n\n.mCS-dark.mCSB_scrollTools .mCSB_buttonDown {\n  background-position: -80px -20px;\n}\n\n.mCS-dark.mCSB_scrollTools .mCSB_buttonLeft {\n  background-position: -80px -40px;\n}\n\n.mCS-dark.mCSB_scrollTools .mCSB_buttonRight {\n  background-position: -80px -56px;\n}\n\n/* ---------------------------------------- */\n\n/* theme: \"light-2\", \"dark-2\" */\n\n.mCS-light-2.mCSB_scrollTools .mCSB_draggerRail,\n.mCS-dark-2.mCSB_scrollTools .mCSB_draggerRail {\n  width: 4px;\n  background-color: #fff;\n  background-color: rgba(255, 255, 255, 0.1);\n  -webkit-border-radius: 1px;\n  -moz-border-radius: 1px;\n  border-radius: 1px;\n}\n\n.mCS-light-2.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,\n.mCS-dark-2.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar {\n  width: 4px;\n  background-color: #fff;\n  background-color: rgba(255, 255, 255, 0.75);\n  -webkit-border-radius: 1px;\n  -moz-border-radius: 1px;\n  border-radius: 1px;\n}\n\n.mCS-light-2.mCSB_scrollTools_horizontal .mCSB_draggerRail,\n.mCS-dark-2.mCSB_scrollTools_horizontal .mCSB_draggerRail,\n.mCS-light-2.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar,\n.mCS-dark-2.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar {\n  width: 100%;\n  height: 4px;\n  margin: 6px auto;\n}\n\n.mCS-light-2.mCSB_scrollTools .mCSB_dragger:hover .mCSB_dragger_bar {\n  background-color: #fff;\n  background-color: rgba(255, 255, 255, 0.85);\n}\n\n.mCS-light-2.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar,\n.mCS-light-2.mCSB_scrollTools\n  .mCSB_dragger.mCSB_dragger_onDrag\n  .mCSB_dragger_bar {\n  background-color: #fff;\n  background-color: rgba(255, 255, 255, 0.9);\n}\n\n.mCS-light-2.mCSB_scrollTools .mCSB_buttonUp {\n  background-position: -32px 0;\n}\n\n.mCS-light-2.mCSB_scrollTools .mCSB_buttonDown {\n  background-position: -32px -20px;\n}\n\n.mCS-light-2.mCSB_scrollTools .mCSB_buttonLeft {\n  background-position: -40px -40px;\n}\n\n.mCS-light-2.mCSB_scrollTools .mCSB_buttonRight {\n  background-position: -40px -56px;\n}\n\n/* theme: \"dark-2\" */\n\n.mCS-dark-2.mCSB_scrollTools .mCSB_draggerRail {\n  background-color: #000;\n  background-color: rgba(0, 0, 0, 0.1);\n  -webkit-border-radius: 1px;\n  -moz-border-radius: 1px;\n  border-radius: 1px;\n}\n\n.mCS-dark-2.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar {\n  background-color: #000;\n  background-color: rgba(0, 0, 0, 0.75);\n  -webkit-border-radius: 1px;\n  -moz-border-radius: 1px;\n  border-radius: 1px;\n}\n\n.mCS-dark-2.mCSB_scrollTools .mCSB_dragger:hover .mCSB_dragger_bar {\n  background-color: #000;\n  background-color: rgba(0, 0, 0, 0.85);\n}\n\n.mCS-dark-2.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar,\n.mCS-dark-2.mCSB_scrollTools\n  .mCSB_dragger.mCSB_dragger_onDrag\n  .mCSB_dragger_bar {\n  background-color: #000;\n  background-color: rgba(0, 0, 0, 0.9);\n}\n\n.mCS-dark-2.mCSB_scrollTools .mCSB_buttonUp {\n  background-position: -112px 0;\n}\n\n.mCS-dark-2.mCSB_scrollTools .mCSB_buttonDown {\n  background-position: -112px -20px;\n}\n\n.mCS-dark-2.mCSB_scrollTools .mCSB_buttonLeft {\n  background-position: -120px -40px;\n}\n\n.mCS-dark-2.mCSB_scrollTools .mCSB_buttonRight {\n  background-position: -120px -56px;\n}\n\n/* ---------------------------------------- */\n\n/* theme: \"light-thick\", \"dark-thick\" */\n\n.mCS-light-thick.mCSB_scrollTools .mCSB_draggerRail,\n.mCS-dark-thick.mCSB_scrollTools .mCSB_draggerRail {\n  width: 4px;\n  background-color: #fff;\n  background-color: rgba(255, 255, 255, 0.1);\n  -webkit-border-radius: 2px;\n  -moz-border-radius: 2px;\n  border-radius: 2px;\n}\n\n.mCS-light-thick.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,\n.mCS-dark-thick.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar {\n  width: 6px;\n  background-color: #fff;\n  background-color: rgba(255, 255, 255, 0.75);\n  -webkit-border-radius: 2px;\n  -moz-border-radius: 2px;\n  border-radius: 2px;\n}\n\n.mCS-light-thick.mCSB_scrollTools_horizontal .mCSB_draggerRail,\n.mCS-dark-thick.mCSB_scrollTools_horizontal .mCSB_draggerRail {\n  width: 100%;\n  height: 4px;\n  margin: 6px 0;\n}\n\n.mCS-light-thick.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar,\n.mCS-dark-thick.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar {\n  width: 100%;\n  height: 6px;\n  margin: 5px auto;\n}\n\n.mCS-light-thick.mCSB_scrollTools .mCSB_dragger:hover .mCSB_dragger_bar {\n  background-color: #fff;\n  background-color: rgba(255, 255, 255, 0.85);\n}\n\n.mCS-light-thick.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar,\n.mCS-light-thick.mCSB_scrollTools\n  .mCSB_dragger.mCSB_dragger_onDrag\n  .mCSB_dragger_bar {\n  background-color: #fff;\n  background-color: rgba(255, 255, 255, 0.9);\n}\n\n.mCS-light-thick.mCSB_scrollTools .mCSB_buttonUp {\n  background-position: -16px 0;\n}\n\n.mCS-light-thick.mCSB_scrollTools .mCSB_buttonDown {\n  background-position: -16px -20px;\n}\n\n.mCS-light-thick.mCSB_scrollTools .mCSB_buttonLeft {\n  background-position: -20px -40px;\n}\n\n.mCS-light-thick.mCSB_scrollTools .mCSB_buttonRight {\n  background-position: -20px -56px;\n}\n\n/* theme: \"dark-thick\" */\n\n.mCS-dark-thick.mCSB_scrollTools .mCSB_draggerRail {\n  background-color: #000;\n  background-color: rgba(0, 0, 0, 0.1);\n  -webkit-border-radius: 2px;\n  -moz-border-radius: 2px;\n  border-radius: 2px;\n}\n\n.mCS-dark-thick.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar {\n  background-color: #000;\n  background-color: rgba(0, 0, 0, 0.75);\n  -webkit-border-radius: 2px;\n  -moz-border-radius: 2px;\n  border-radius: 2px;\n}\n\n.mCS-dark-thick.mCSB_scrollTools .mCSB_dragger:hover .mCSB_dragger_bar {\n  background-color: #000;\n  background-color: rgba(0, 0, 0, 0.85);\n}\n\n.mCS-dark-thick.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar,\n.mCS-dark-thick.mCSB_scrollTools\n  .mCSB_dragger.mCSB_dragger_onDrag\n  .mCSB_dragger_bar {\n  background-color: #000;\n  background-color: rgba(0, 0, 0, 0.9);\n}\n\n.mCS-dark-thick.mCSB_scrollTools .mCSB_buttonUp {\n  background-position: -96px 0;\n}\n\n.mCS-dark-thick.mCSB_scrollTools .mCSB_buttonDown {\n  background-position: -96px -20px;\n}\n\n.mCS-dark-thick.mCSB_scrollTools .mCSB_buttonLeft {\n  background-position: -100px -40px;\n}\n\n.mCS-dark-thick.mCSB_scrollTools .mCSB_buttonRight {\n  background-position: -100px -56px;\n}\n\n/* ---------------------------------------- */\n\n/* theme: \"light-thin\", \"dark-thin\" */\n\n.mCS-light-thin.mCSB_scrollTools .mCSB_draggerRail {\n  background-color: #fff;\n  background-color: rgba(255, 255, 255, 0.1);\n}\n\n.mCS-light-thin.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,\n.mCS-dark-thin.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar {\n  width: 2px;\n}\n\n.mCS-light-thin.mCSB_scrollTools_horizontal .mCSB_draggerRail,\n.mCS-dark-thin.mCSB_scrollTools_horizontal .mCSB_draggerRail {\n  width: 100%;\n}\n\n.mCS-light-thin.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar,\n.mCS-dark-thin.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar {\n  width: 100%;\n  height: 2px;\n  margin: 7px auto;\n}\n\n/* theme \"dark-thin\" */\n\n.mCS-dark-thin.mCSB_scrollTools .mCSB_draggerRail {\n  background-color: #000;\n  background-color: rgba(0, 0, 0, 0.15);\n}\n\n.mCS-dark-thin.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar {\n  background-color: #000;\n  background-color: rgba(0, 0, 0, 0.75);\n}\n\n.mCS-dark-thin.mCSB_scrollTools .mCSB_dragger:hover .mCSB_dragger_bar {\n  background-color: #000;\n  background-color: rgba(0, 0, 0, 0.85);\n}\n\n.mCS-dark-thin.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar,\n.mCS-dark-thin.mCSB_scrollTools\n  .mCSB_dragger.mCSB_dragger_onDrag\n  .mCSB_dragger_bar {\n  background-color: #000;\n  background-color: rgba(0, 0, 0, 0.9);\n}\n\n.mCS-dark-thin.mCSB_scrollTools .mCSB_buttonUp {\n  background-position: -80px 0;\n}\n\n.mCS-dark-thin.mCSB_scrollTools .mCSB_buttonDown {\n  background-position: -80px -20px;\n}\n\n.mCS-dark-thin.mCSB_scrollTools .mCSB_buttonLeft {\n  background-position: -80px -40px;\n}\n\n.mCS-dark-thin.mCSB_scrollTools .mCSB_buttonRight {\n  background-position: -80px -56px;\n}\n\n/* ---------------------------------------- */\n\n/* theme \"rounded\", \"rounded-dark\", \"rounded-dots\", \"rounded-dots-dark\" */\n\n.mCS-rounded.mCSB_scrollTools .mCSB_draggerRail {\n  background-color: #fff;\n  background-color: rgba(255, 255, 255, 0.15);\n}\n\n.mCS-rounded.mCSB_scrollTools .mCSB_dragger,\n.mCS-rounded-dark.mCSB_scrollTools .mCSB_dragger,\n.mCS-rounded-dots.mCSB_scrollTools .mCSB_dragger,\n.mCS-rounded-dots-dark.mCSB_scrollTools .mCSB_dragger {\n  height: 14px;\n}\n\n.mCS-rounded.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,\n.mCS-rounded-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,\n.mCS-rounded-dots.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,\n.mCS-rounded-dots-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar {\n  width: 14px;\n  margin: 0 1px;\n}\n\n.mCS-rounded.mCSB_scrollTools_horizontal .mCSB_dragger,\n.mCS-rounded-dark.mCSB_scrollTools_horizontal .mCSB_dragger,\n.mCS-rounded-dots.mCSB_scrollTools_horizontal .mCSB_dragger,\n.mCS-rounded-dots-dark.mCSB_scrollTools_horizontal .mCSB_dragger {\n  width: 14px;\n}\n\n.mCS-rounded.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar,\n.mCS-rounded-dark.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar,\n.mCS-rounded-dots.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar,\n.mCS-rounded-dots-dark.mCSB_scrollTools_horizontal\n  .mCSB_dragger\n  .mCSB_dragger_bar {\n  height: 14px;\n  margin: 1px 0;\n}\n\n.mCS-rounded.mCSB_scrollTools_vertical.mCSB_scrollTools_onDrag_expand\n  .mCSB_dragger.mCSB_dragger_onDrag_expanded\n  .mCSB_dragger_bar,\n.mCS-rounded.mCSB_scrollTools_vertical.mCSB_scrollTools_onDrag_expand\n  .mCSB_draggerContainer:hover\n  .mCSB_dragger\n  .mCSB_dragger_bar,\n.mCS-rounded-dark.mCSB_scrollTools_vertical.mCSB_scrollTools_onDrag_expand\n  .mCSB_dragger.mCSB_dragger_onDrag_expanded\n  .mCSB_dragger_bar,\n.mCS-rounded-dark.mCSB_scrollTools_vertical.mCSB_scrollTools_onDrag_expand\n  .mCSB_draggerContainer:hover\n  .mCSB_dragger\n  .mCSB_dragger_bar {\n  width: 16px; /* auto-expanded scrollbar */\n  height: 16px;\n  margin: -1px 0;\n}\n\n.mCS-rounded.mCSB_scrollTools_vertical.mCSB_scrollTools_onDrag_expand\n  .mCSB_dragger.mCSB_dragger_onDrag_expanded\n  + .mCSB_draggerRail,\n.mCS-rounded.mCSB_scrollTools_vertical.mCSB_scrollTools_onDrag_expand\n  .mCSB_draggerContainer:hover\n  .mCSB_draggerRail,\n.mCS-rounded-dark.mCSB_scrollTools_vertical.mCSB_scrollTools_onDrag_expand\n  .mCSB_dragger.mCSB_dragger_onDrag_expanded\n  + .mCSB_draggerRail,\n.mCS-rounded-dark.mCSB_scrollTools_vertical.mCSB_scrollTools_onDrag_expand\n  .mCSB_draggerContainer:hover\n  .mCSB_draggerRail {\n  width: 4px; /* auto-expanded scrollbar */\n}\n\n.mCS-rounded.mCSB_scrollTools_horizontal.mCSB_scrollTools_onDrag_expand\n  .mCSB_dragger.mCSB_dragger_onDrag_expanded\n  .mCSB_dragger_bar,\n.mCS-rounded.mCSB_scrollTools_horizontal.mCSB_scrollTools_onDrag_expand\n  .mCSB_draggerContainer:hover\n  .mCSB_dragger\n  .mCSB_dragger_bar,\n.mCS-rounded-dark.mCSB_scrollTools_horizontal.mCSB_scrollTools_onDrag_expand\n  .mCSB_dragger.mCSB_dragger_onDrag_expanded\n  .mCSB_dragger_bar,\n.mCS-rounded-dark.mCSB_scrollTools_horizontal.mCSB_scrollTools_onDrag_expand\n  .mCSB_draggerContainer:hover\n  .mCSB_dragger\n  .mCSB_dragger_bar {\n  height: 16px; /* auto-expanded scrollbar */\n  width: 16px;\n  margin: 0 -1px;\n}\n\n.mCS-rounded.mCSB_scrollTools_horizontal.mCSB_scrollTools_onDrag_expand\n  .mCSB_dragger.mCSB_dragger_onDrag_expanded\n  + .mCSB_draggerRail,\n.mCS-rounded.mCSB_scrollTools_horizontal.mCSB_scrollTools_onDrag_expand\n  .mCSB_draggerContainer:hover\n  .mCSB_draggerRail,\n.mCS-rounded-dark.mCSB_scrollTools_horizontal.mCSB_scrollTools_onDrag_expand\n  .mCSB_dragger.mCSB_dragger_onDrag_expanded\n  + .mCSB_draggerRail,\n.mCS-rounded-dark.mCSB_scrollTools_horizontal.mCSB_scrollTools_onDrag_expand\n  .mCSB_draggerContainer:hover\n  .mCSB_draggerRail {\n  height: 4px; /* auto-expanded scrollbar */\n  margin: 6px 0;\n}\n\n.mCS-rounded.mCSB_scrollTools .mCSB_buttonUp {\n  background-position: 0 -72px;\n}\n\n.mCS-rounded.mCSB_scrollTools .mCSB_buttonDown {\n  background-position: 0 -92px;\n}\n\n.mCS-rounded.mCSB_scrollTools .mCSB_buttonLeft {\n  background-position: 0 -112px;\n}\n\n.mCS-rounded.mCSB_scrollTools .mCSB_buttonRight {\n  background-position: 0 -128px;\n}\n\n/* theme \"rounded-dark\", \"rounded-dots-dark\" */\n\n.mCS-rounded-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,\n.mCS-rounded-dots-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar {\n  background-color: #000;\n  background-color: rgba(0, 0, 0, 0.75);\n}\n\n.mCS-rounded-dark.mCSB_scrollTools .mCSB_draggerRail {\n  background-color: #000;\n  background-color: rgba(0, 0, 0, 0.15);\n}\n\n.mCS-rounded-dark.mCSB_scrollTools .mCSB_dragger:hover .mCSB_dragger_bar,\n.mCS-rounded-dots-dark.mCSB_scrollTools .mCSB_dragger:hover .mCSB_dragger_bar {\n  background-color: #000;\n  background-color: rgba(0, 0, 0, 0.85);\n}\n\n.mCS-rounded-dark.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar,\n.mCS-rounded-dark.mCSB_scrollTools\n  .mCSB_dragger.mCSB_dragger_onDrag\n  .mCSB_dragger_bar,\n.mCS-rounded-dots-dark.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar,\n.mCS-rounded-dots-dark.mCSB_scrollTools\n  .mCSB_dragger.mCSB_dragger_onDrag\n  .mCSB_dragger_bar {\n  background-color: #000;\n  background-color: rgba(0, 0, 0, 0.9);\n}\n\n.mCS-rounded-dark.mCSB_scrollTools .mCSB_buttonUp {\n  background-position: -80px -72px;\n}\n\n.mCS-rounded-dark.mCSB_scrollTools .mCSB_buttonDown {\n  background-position: -80px -92px;\n}\n\n.mCS-rounded-dark.mCSB_scrollTools .mCSB_buttonLeft {\n  background-position: -80px -112px;\n}\n\n.mCS-rounded-dark.mCSB_scrollTools .mCSB_buttonRight {\n  background-position: -80px -128px;\n}\n\n/* theme \"rounded-dots\", \"rounded-dots-dark\" */\n\n.mCS-rounded-dots.mCSB_scrollTools_vertical .mCSB_draggerRail,\n.mCS-rounded-dots-dark.mCSB_scrollTools_vertical .mCSB_draggerRail {\n  width: 4px;\n}\n\n.mCS-rounded-dots.mCSB_scrollTools .mCSB_draggerRail,\n.mCS-rounded-dots-dark.mCSB_scrollTools .mCSB_draggerRail,\n.mCS-rounded-dots.mCSB_scrollTools_horizontal .mCSB_draggerRail,\n.mCS-rounded-dots-dark.mCSB_scrollTools_horizontal .mCSB_draggerRail {\n  background-color: transparent;\n  background-position: center;\n}\n\n.mCS-rounded-dots.mCSB_scrollTools .mCSB_draggerRail,\n.mCS-rounded-dots-dark.mCSB_scrollTools .mCSB_draggerRail {\n  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAANElEQVQYV2NkIAAYiVbw//9/Y6DiM1ANJoyMjGdBbLgJQAX/kU0DKgDLkaQAvxW4HEvQFwCRcxIJK1XznAAAAABJRU5ErkJggg==');\n  background-repeat: repeat-y;\n  opacity: 0.3;\n  filter: 'alpha(opacity=30)';\n  -ms-filter: 'alpha(opacity=30)';\n}\n\n.mCS-rounded-dots.mCSB_scrollTools_horizontal .mCSB_draggerRail,\n.mCS-rounded-dots-dark.mCSB_scrollTools_horizontal .mCSB_draggerRail {\n  height: 4px;\n  margin: 6px 0;\n  background-repeat: repeat-x;\n}\n\n.mCS-rounded-dots.mCSB_scrollTools .mCSB_buttonUp {\n  background-position: -16px -72px;\n}\n\n.mCS-rounded-dots.mCSB_scrollTools .mCSB_buttonDown {\n  background-position: -16px -92px;\n}\n\n.mCS-rounded-dots.mCSB_scrollTools .mCSB_buttonLeft {\n  background-position: -20px -112px;\n}\n\n.mCS-rounded-dots.mCSB_scrollTools .mCSB_buttonRight {\n  background-position: -20px -128px;\n}\n\n/* theme \"rounded-dots-dark\" */\n\n.mCS-rounded-dots-dark.mCSB_scrollTools .mCSB_draggerRail {\n  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAALElEQVQYV2NkIAAYSVFgDFR8BqrBBEifBbGRTfiPZhpYjiQFBK3A6l6CvgAAE9kGCd1mvgEAAAAASUVORK5CYII=');\n}\n\n.mCS-rounded-dots-dark.mCSB_scrollTools .mCSB_buttonUp {\n  background-position: -96px -72px;\n}\n\n.mCS-rounded-dots-dark.mCSB_scrollTools .mCSB_buttonDown {\n  background-position: -96px -92px;\n}\n\n.mCS-rounded-dots-dark.mCSB_scrollTools .mCSB_buttonLeft {\n  background-position: -100px -112px;\n}\n\n.mCS-rounded-dots-dark.mCSB_scrollTools .mCSB_buttonRight {\n  background-position: -100px -128px;\n}\n\n/* ---------------------------------------- */\n\n/* theme \"3d\", \"3d-dark\", \"3d-thick\", \"3d-thick-dark\" */\n\n.mCS-3d.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,\n.mCS-3d-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,\n.mCS-3d-thick.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,\n.mCS-3d-thick-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar {\n  background-repeat: repeat-y;\n  background-image: -moz-linear-gradient(\n    left,\n    rgba(255, 255, 255, 0.5) 0%,\n    rgba(255, 255, 255, 0) 100%\n  );\n  background-image: -webkit-gradient(\n    linear,\n    left top,\n    right top,\n    color-stop(0%, rgba(255, 255, 255, 0.5)),\n    color-stop(100%, rgba(255, 255, 255, 0))\n  );\n  background-image: -webkit-linear-gradient(\n    left,\n    rgba(255, 255, 255, 0.5) 0%,\n    rgba(255, 255, 255, 0) 100%\n  );\n  background-image: -o-linear-gradient(\n    left,\n    rgba(255, 255, 255, 0.5) 0%,\n    rgba(255, 255, 255, 0) 100%\n  );\n  background-image: -ms-linear-gradient(\n    left,\n    rgba(255, 255, 255, 0.5) 0%,\n    rgba(255, 255, 255, 0) 100%\n  );\n  background-image: linear-gradient(\n    to right,\n    rgba(255, 255, 255, 0.5) 0%,\n    rgba(255, 255, 255, 0) 100%\n  );\n}\n\n.mCS-3d.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar,\n.mCS-3d-dark.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar,\n.mCS-3d-thick.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar,\n.mCS-3d-thick-dark.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar {\n  background-repeat: repeat-x;\n  background-image: -moz-linear-gradient(\n    top,\n    rgba(255, 255, 255, 0.5) 0%,\n    rgba(255, 255, 255, 0) 100%\n  );\n  background-image: -webkit-gradient(\n    linear,\n    left top,\n    left bottom,\n    color-stop(0%, rgba(255, 255, 255, 0.5)),\n    color-stop(100%, rgba(255, 255, 255, 0))\n  );\n  background-image: -webkit-linear-gradient(\n    top,\n    rgba(255, 255, 255, 0.5) 0%,\n    rgba(255, 255, 255, 0) 100%\n  );\n  background-image: -o-linear-gradient(\n    top,\n    rgba(255, 255, 255, 0.5) 0%,\n    rgba(255, 255, 255, 0) 100%\n  );\n  background-image: -ms-linear-gradient(\n    top,\n    rgba(255, 255, 255, 0.5) 0%,\n    rgba(255, 255, 255, 0) 100%\n  );\n  background-image: linear-gradient(\n    to bottom,\n    rgba(255, 255, 255, 0.5) 0%,\n    rgba(255, 255, 255, 0) 100%\n  );\n}\n\n/* theme \"3d\", \"3d-dark\" */\n\n.mCS-3d.mCSB_scrollTools_vertical .mCSB_dragger,\n.mCS-3d-dark.mCSB_scrollTools_vertical .mCSB_dragger {\n  height: 70px;\n}\n\n.mCS-3d.mCSB_scrollTools_horizontal .mCSB_dragger,\n.mCS-3d-dark.mCSB_scrollTools_horizontal .mCSB_dragger {\n  width: 70px;\n}\n\n.mCS-3d.mCSB_scrollTools,\n.mCS-3d-dark.mCSB_scrollTools {\n  opacity: 1;\n  filter: 'alpha(opacity=30)';\n  -ms-filter: 'alpha(opacity=30)';\n}\n\n.mCS-3d.mCSB_scrollTools .mCSB_draggerRail,\n.mCS-3d.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,\n.mCS-3d-dark.mCSB_scrollTools .mCSB_draggerRail,\n.mCS-3d-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar {\n  -webkit-border-radius: 16px;\n  -moz-border-radius: 16px;\n  border-radius: 16px;\n}\n\n.mCS-3d.mCSB_scrollTools .mCSB_draggerRail,\n.mCS-3d-dark.mCSB_scrollTools .mCSB_draggerRail {\n  width: 8px;\n  background-color: #000;\n  background-color: rgba(0, 0, 0, 0.2);\n  box-shadow:\n    inset 1px 0 1px rgba(0, 0, 0, 0.5),\n    inset -1px 0 1px rgba(255, 255, 255, 0.2);\n}\n\n.mCS-3d.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,\n.mCS-3d.mCSB_scrollTools .mCSB_dragger:hover .mCSB_dragger_bar,\n.mCS-3d.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar,\n.mCS-3d.mCSB_scrollTools .mCSB_dragger.mCSB_dragger_onDrag .mCSB_dragger_bar,\n.mCS-3d-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,\n.mCS-3d-dark.mCSB_scrollTools .mCSB_dragger:hover .mCSB_dragger_bar,\n.mCS-3d-dark.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar,\n.mCS-3d-dark.mCSB_scrollTools\n  .mCSB_dragger.mCSB_dragger_onDrag\n  .mCSB_dragger_bar {\n  background-color: #555;\n}\n\n.mCS-3d.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,\n.mCS-3d-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar {\n  width: 8px;\n}\n\n.mCS-3d.mCSB_scrollTools_horizontal .mCSB_draggerRail,\n.mCS-3d-dark.mCSB_scrollTools_horizontal .mCSB_draggerRail {\n  width: 100%;\n  height: 8px;\n  margin: 4px 0;\n  box-shadow:\n    inset 0 1px 1px rgba(0, 0, 0, 0.5),\n    inset 0 -1px 1px rgba(255, 255, 255, 0.2);\n}\n\n.mCS-3d.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar,\n.mCS-3d-dark.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar {\n  width: 100%;\n  height: 8px;\n  margin: 4px auto;\n}\n\n.mCS-3d.mCSB_scrollTools .mCSB_buttonUp {\n  background-position: -32px -72px;\n}\n\n.mCS-3d.mCSB_scrollTools .mCSB_buttonDown {\n  background-position: -32px -92px;\n}\n\n.mCS-3d.mCSB_scrollTools .mCSB_buttonLeft {\n  background-position: -40px -112px;\n}\n\n.mCS-3d.mCSB_scrollTools .mCSB_buttonRight {\n  background-position: -40px -128px;\n}\n\n/* theme \"3d-dark\" */\n\n.mCS-3d-dark.mCSB_scrollTools .mCSB_draggerRail {\n  background-color: #000;\n  background-color: rgba(0, 0, 0, 0.1);\n  box-shadow: inset 1px 0 1px rgba(0, 0, 0, 0.1);\n}\n\n.mCS-3d-dark.mCSB_scrollTools_horizontal .mCSB_draggerRail {\n  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.1);\n}\n\n.mCS-3d-dark.mCSB_scrollTools .mCSB_buttonUp {\n  background-position: -112px -72px;\n}\n\n.mCS-3d-dark.mCSB_scrollTools .mCSB_buttonDown {\n  background-position: -112px -92px;\n}\n\n.mCS-3d-dark.mCSB_scrollTools .mCSB_buttonLeft {\n  background-position: -120px -112px;\n}\n\n.mCS-3d-dark.mCSB_scrollTools .mCSB_buttonRight {\n  background-position: -120px -128px;\n}\n\n/* ---------------------------------------- */\n\n/* theme: \"3d-thick\", \"3d-thick-dark\" */\n\n.mCS-3d-thick.mCSB_scrollTools,\n.mCS-3d-thick-dark.mCSB_scrollTools {\n  opacity: 1;\n  filter: 'alpha(opacity=30)';\n  -ms-filter: 'alpha(opacity=30)';\n}\n\n.mCS-3d-thick.mCSB_scrollTools,\n.mCS-3d-thick-dark.mCSB_scrollTools,\n.mCS-3d-thick.mCSB_scrollTools .mCSB_draggerContainer,\n.mCS-3d-thick-dark.mCSB_scrollTools .mCSB_draggerContainer {\n  -webkit-border-radius: 7px;\n  -moz-border-radius: 7px;\n  border-radius: 7px;\n}\n\n.mCS-3d-thick.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,\n.mCS-3d-thick-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar {\n  -webkit-border-radius: 5px;\n  -moz-border-radius: 5px;\n  border-radius: 5px;\n}\n\n.mCSB_inside + .mCS-3d-thick.mCSB_scrollTools_vertical,\n.mCSB_inside + .mCS-3d-thick-dark.mCSB_scrollTools_vertical {\n  right: 1px;\n}\n\n.mCS-3d-thick.mCSB_scrollTools_vertical,\n.mCS-3d-thick-dark.mCSB_scrollTools_vertical {\n  box-shadow:\n    inset 1px 0 1px rgba(0, 0, 0, 0.1),\n    inset 0 0 14px rgba(0, 0, 0, 0.5);\n}\n\n.mCS-3d-thick.mCSB_scrollTools_horizontal,\n.mCS-3d-thick-dark.mCSB_scrollTools_horizontal {\n  bottom: 1px;\n  box-shadow:\n    inset 0 1px 1px rgba(0, 0, 0, 0.1),\n    inset 0 0 14px rgba(0, 0, 0, 0.5);\n}\n\n.mCS-3d-thick.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,\n.mCS-3d-thick-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar {\n  box-shadow: inset 1px 0 0 rgba(255, 255, 255, 0.4);\n  width: 12px;\n  margin: 2px;\n  position: absolute;\n  height: auto;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n}\n\n.mCS-3d-thick.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar,\n.mCS-3d-thick-dark.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar {\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.4);\n}\n\n.mCS-3d-thick.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,\n.mCS-3d-thick.mCSB_scrollTools .mCSB_dragger:hover .mCSB_dragger_bar,\n.mCS-3d-thick.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar,\n.mCS-3d-thick.mCSB_scrollTools\n  .mCSB_dragger.mCSB_dragger_onDrag\n  .mCSB_dragger_bar {\n  background-color: #555;\n}\n\n.mCS-3d-thick.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar,\n.mCS-3d-thick-dark.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar {\n  height: 12px;\n  width: auto;\n}\n\n.mCS-3d-thick.mCSB_scrollTools .mCSB_draggerContainer {\n  background-color: #000;\n  background-color: rgba(0, 0, 0, 0.05);\n  box-shadow: inset 1px 1px 16px rgba(0, 0, 0, 0.1);\n}\n\n.mCS-3d-thick.mCSB_scrollTools .mCSB_draggerRail {\n  background-color: transparent;\n}\n\n.mCS-3d-thick.mCSB_scrollTools .mCSB_buttonUp {\n  background-position: -32px -72px;\n}\n\n.mCS-3d-thick.mCSB_scrollTools .mCSB_buttonDown {\n  background-position: -32px -92px;\n}\n\n.mCS-3d-thick.mCSB_scrollTools .mCSB_buttonLeft {\n  background-position: -40px -112px;\n}\n\n.mCS-3d-thick.mCSB_scrollTools .mCSB_buttonRight {\n  background-position: -40px -128px;\n}\n\n/* theme: \"3d-thick-dark\" */\n\n.mCS-3d-thick-dark.mCSB_scrollTools {\n  box-shadow: inset 0 0 14px rgba(0, 0, 0, 0.2);\n}\n\n.mCS-3d-thick-dark.mCSB_scrollTools_horizontal {\n  box-shadow:\n    inset 0 1px 1px rgba(0, 0, 0, 0.1),\n    inset 0 0 14px rgba(0, 0, 0, 0.2);\n}\n\n.mCS-3d-thick-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar {\n  box-shadow:\n    inset 1px 0 0 rgba(255, 255, 255, 0.4),\n    inset -1px 0 0 rgba(0, 0, 0, 0.2);\n}\n\n.mCS-3d-thick-dark.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar {\n  box-shadow:\n    inset 0 1px 0 rgba(255, 255, 255, 0.4),\n    inset 0 -1px 0 rgba(0, 0, 0, 0.2);\n}\n\n.mCS-3d-thick-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,\n.mCS-3d-thick-dark.mCSB_scrollTools .mCSB_dragger:hover .mCSB_dragger_bar,\n.mCS-3d-thick-dark.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar,\n.mCS-3d-thick-dark.mCSB_scrollTools\n  .mCSB_dragger.mCSB_dragger_onDrag\n  .mCSB_dragger_bar {\n  background-color: #777;\n}\n\n.mCS-3d-thick-dark.mCSB_scrollTools .mCSB_draggerContainer {\n  background-color: #fff;\n  background-color: rgba(0, 0, 0, 0.05);\n  box-shadow: inset 1px 1px 16px rgba(0, 0, 0, 0.1);\n}\n\n.mCS-3d-thick-dark.mCSB_scrollTools .mCSB_draggerRail {\n  background-color: transparent;\n}\n\n.mCS-3d-thick-dark.mCSB_scrollTools .mCSB_buttonUp {\n  background-position: -112px -72px;\n}\n\n.mCS-3d-thick-dark.mCSB_scrollTools .mCSB_buttonDown {\n  background-position: -112px -92px;\n}\n\n.mCS-3d-thick-dark.mCSB_scrollTools .mCSB_buttonLeft {\n  background-position: -120px -112px;\n}\n\n.mCS-3d-thick-dark.mCSB_scrollTools .mCSB_buttonRight {\n  background-position: -120px -128px;\n}\n\n/* ---------------------------------------- */\n\n/* theme: \"minimal\", \"minimal-dark\" */\n\n.mCSB_outside + .mCS-minimal.mCSB_scrollTools_vertical,\n.mCSB_outside + .mCS-minimal-dark.mCSB_scrollTools_vertical {\n  right: 0;\n  margin: 12px 0;\n}\n\n.mCustomScrollBox.mCS-minimal + .mCSB_scrollTools.mCSB_scrollTools_horizontal,\n.mCustomScrollBox.mCS-minimal\n  + .mCSB_scrollTools\n  + .mCSB_scrollTools.mCSB_scrollTools_horizontal,\n.mCustomScrollBox.mCS-minimal-dark\n  + .mCSB_scrollTools.mCSB_scrollTools_horizontal,\n.mCustomScrollBox.mCS-minimal-dark\n  + .mCSB_scrollTools\n  + .mCSB_scrollTools.mCSB_scrollTools_horizontal {\n  bottom: 0;\n  margin: 0 12px;\n}\n\n/* RTL direction/left-side scrollbar */\n.mCS-dir-rtl > .mCSB_outside + .mCS-minimal.mCSB_scrollTools_vertical,\n.mCS-dir-rtl > .mCSB_outside + .mCS-minimal-dark.mCSB_scrollTools_vertical {\n  left: 0;\n  right: auto;\n}\n\n.mCS-minimal.mCSB_scrollTools .mCSB_draggerRail,\n.mCS-minimal-dark.mCSB_scrollTools .mCSB_draggerRail {\n  background-color: transparent;\n}\n\n.mCS-minimal.mCSB_scrollTools_vertical .mCSB_dragger,\n.mCS-minimal-dark.mCSB_scrollTools_vertical .mCSB_dragger {\n  height: 50px;\n}\n\n.mCS-minimal.mCSB_scrollTools_horizontal .mCSB_dragger,\n.mCS-minimal-dark.mCSB_scrollTools_horizontal .mCSB_dragger {\n  width: 50px;\n}\n\n.mCS-minimal.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar {\n  background-color: #fff;\n  background-color: rgba(255, 255, 255, 0.2);\n  filter: 'alpha(opacity=20)';\n  -ms-filter: 'alpha(opacity=20)';\n}\n\n.mCS-minimal.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar,\n.mCS-minimal.mCSB_scrollTools\n  .mCSB_dragger.mCSB_dragger_onDrag\n  .mCSB_dragger_bar {\n  background-color: #fff;\n  background-color: rgba(255, 255, 255, 0.5);\n  filter: 'alpha(opacity=50)';\n  -ms-filter: 'alpha(opacity=50)';\n}\n\n/* theme: \"minimal-dark\" */\n\n.mCS-minimal-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar {\n  background-color: #000;\n  background-color: rgba(0, 0, 0, 0.2);\n  filter: 'alpha(opacity=20)';\n  -ms-filter: 'alpha(opacity=20)';\n}\n\n.mCS-minimal-dark.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar,\n.mCS-minimal-dark.mCSB_scrollTools\n  .mCSB_dragger.mCSB_dragger_onDrag\n  .mCSB_dragger_bar {\n  background-color: #000;\n  background-color: rgba(0, 0, 0, 0.5);\n  filter: 'alpha(opacity=50)';\n  -ms-filter: 'alpha(opacity=50)';\n}\n\n/* ---------------------------------------- */\n\n/* theme \"light-3\", \"dark-3\" */\n\n.mCS-light-3.mCSB_scrollTools .mCSB_draggerRail,\n.mCS-dark-3.mCSB_scrollTools .mCSB_draggerRail {\n  width: 6px;\n  background-color: #000;\n  background-color: rgba(0, 0, 0, 0.2);\n}\n\n.mCS-light-3.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,\n.mCS-dark-3.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar {\n  width: 6px;\n}\n\n.mCS-light-3.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar,\n.mCS-dark-3.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar,\n.mCS-light-3.mCSB_scrollTools_horizontal .mCSB_draggerRail,\n.mCS-dark-3.mCSB_scrollTools_horizontal .mCSB_draggerRail {\n  width: 100%;\n  height: 6px;\n  margin: 5px 0;\n}\n\n.mCS-light-3.mCSB_scrollTools_vertical.mCSB_scrollTools_onDrag_expand\n  .mCSB_dragger.mCSB_dragger_onDrag_expanded\n  + .mCSB_draggerRail,\n.mCS-light-3.mCSB_scrollTools_vertical.mCSB_scrollTools_onDrag_expand\n  .mCSB_draggerContainer:hover\n  .mCSB_draggerRail,\n.mCS-dark-3.mCSB_scrollTools_vertical.mCSB_scrollTools_onDrag_expand\n  .mCSB_dragger.mCSB_dragger_onDrag_expanded\n  + .mCSB_draggerRail,\n.mCS-dark-3.mCSB_scrollTools_vertical.mCSB_scrollTools_onDrag_expand\n  .mCSB_draggerContainer:hover\n  .mCSB_draggerRail {\n  width: 12px;\n}\n\n.mCS-light-3.mCSB_scrollTools_horizontal.mCSB_scrollTools_onDrag_expand\n  .mCSB_dragger.mCSB_dragger_onDrag_expanded\n  + .mCSB_draggerRail,\n.mCS-light-3.mCSB_scrollTools_horizontal.mCSB_scrollTools_onDrag_expand\n  .mCSB_draggerContainer:hover\n  .mCSB_draggerRail,\n.mCS-dark-3.mCSB_scrollTools_horizontal.mCSB_scrollTools_onDrag_expand\n  .mCSB_dragger.mCSB_dragger_onDrag_expanded\n  + .mCSB_draggerRail,\n.mCS-dark-3.mCSB_scrollTools_horizontal.mCSB_scrollTools_onDrag_expand\n  .mCSB_draggerContainer:hover\n  .mCSB_draggerRail {\n  height: 12px;\n  margin: 2px 0;\n}\n\n.mCS-light-3.mCSB_scrollTools .mCSB_buttonUp {\n  background-position: -32px -72px;\n}\n\n.mCS-light-3.mCSB_scrollTools .mCSB_buttonDown {\n  background-position: -32px -92px;\n}\n\n.mCS-light-3.mCSB_scrollTools .mCSB_buttonLeft {\n  background-position: -40px -112px;\n}\n\n.mCS-light-3.mCSB_scrollTools .mCSB_buttonRight {\n  background-position: -40px -128px;\n}\n\n/* theme \"dark-3\" */\n\n.mCS-dark-3.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar {\n  background-color: #000;\n  background-color: rgba(0, 0, 0, 0.75);\n}\n\n.mCS-dark-3.mCSB_scrollTools .mCSB_dragger:hover .mCSB_dragger_bar {\n  background-color: #000;\n  background-color: rgba(0, 0, 0, 0.85);\n}\n\n.mCS-dark-3.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar,\n.mCS-dark-3.mCSB_scrollTools\n  .mCSB_dragger.mCSB_dragger_onDrag\n  .mCSB_dragger_bar {\n  background-color: #000;\n  background-color: rgba(0, 0, 0, 0.9);\n}\n\n.mCS-dark-3.mCSB_scrollTools .mCSB_draggerRail {\n  background-color: #000;\n  background-color: rgba(0, 0, 0, 0.1);\n}\n\n.mCS-dark-3.mCSB_scrollTools .mCSB_buttonUp {\n  background-position: -112px -72px;\n}\n\n.mCS-dark-3.mCSB_scrollTools .mCSB_buttonDown {\n  background-position: -112px -92px;\n}\n\n.mCS-dark-3.mCSB_scrollTools .mCSB_buttonLeft {\n  background-position: -120px -112px;\n}\n\n.mCS-dark-3.mCSB_scrollTools .mCSB_buttonRight {\n  background-position: -120px -128px;\n}\n\n/* ---------------------------------------- */\n\n/* theme \"inset\", \"inset-dark\", \"inset-2\", \"inset-2-dark\", \"inset-3\", \"inset-3-dark\" */\n\n.mCS-inset.mCSB_scrollTools .mCSB_draggerRail,\n.mCS-inset-dark.mCSB_scrollTools .mCSB_draggerRail,\n.mCS-inset-2.mCSB_scrollTools .mCSB_draggerRail,\n.mCS-inset-2-dark.mCSB_scrollTools .mCSB_draggerRail,\n.mCS-inset-3.mCSB_scrollTools .mCSB_draggerRail,\n.mCS-inset-3-dark.mCSB_scrollTools .mCSB_draggerRail {\n  width: 12px;\n  background-color: #000;\n  background-color: rgba(0, 0, 0, 0.2);\n}\n\n.mCS-inset.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,\n.mCS-inset-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,\n.mCS-inset-2.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,\n.mCS-inset-2-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,\n.mCS-inset-3.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,\n.mCS-inset-3-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar {\n  width: 6px;\n  margin: 3px 5px;\n  position: absolute;\n  height: auto;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n}\n\n.mCS-inset.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar,\n.mCS-inset-dark.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar,\n.mCS-inset-2.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar,\n.mCS-inset-2-dark.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar,\n.mCS-inset-3.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar,\n.mCS-inset-3-dark.mCSB_scrollTools_horizontal .mCSB_dragger .mCSB_dragger_bar {\n  height: 6px;\n  margin: 5px 3px;\n  position: absolute;\n  width: auto;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n}\n\n.mCS-inset.mCSB_scrollTools_horizontal .mCSB_draggerRail,\n.mCS-inset-dark.mCSB_scrollTools_horizontal .mCSB_draggerRail,\n.mCS-inset-2.mCSB_scrollTools_horizontal .mCSB_draggerRail,\n.mCS-inset-2-dark.mCSB_scrollTools_horizontal .mCSB_draggerRail,\n.mCS-inset-3.mCSB_scrollTools_horizontal .mCSB_draggerRail,\n.mCS-inset-3-dark.mCSB_scrollTools_horizontal .mCSB_draggerRail {\n  width: 100%;\n  height: 12px;\n  margin: 2px 0;\n}\n\n.mCS-inset.mCSB_scrollTools .mCSB_buttonUp,\n.mCS-inset-2.mCSB_scrollTools .mCSB_buttonUp,\n.mCS-inset-3.mCSB_scrollTools .mCSB_buttonUp {\n  background-position: -32px -72px;\n}\n\n.mCS-inset.mCSB_scrollTools .mCSB_buttonDown,\n.mCS-inset-2.mCSB_scrollTools .mCSB_buttonDown,\n.mCS-inset-3.mCSB_scrollTools .mCSB_buttonDown {\n  background-position: -32px -92px;\n}\n\n.mCS-inset.mCSB_scrollTools .mCSB_buttonLeft,\n.mCS-inset-2.mCSB_scrollTools .mCSB_buttonLeft,\n.mCS-inset-3.mCSB_scrollTools .mCSB_buttonLeft {\n  background-position: -40px -112px;\n}\n\n.mCS-inset.mCSB_scrollTools .mCSB_buttonRight,\n.mCS-inset-2.mCSB_scrollTools .mCSB_buttonRight,\n.mCS-inset-3.mCSB_scrollTools .mCSB_buttonRight {\n  background-position: -40px -128px;\n}\n\n/* theme \"inset-dark\", \"inset-2-dark\", \"inset-3-dark\" */\n\n.mCS-inset-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,\n.mCS-inset-2-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar,\n.mCS-inset-3-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar {\n  background-color: #000;\n  background-color: rgba(0, 0, 0, 0.75);\n}\n\n.mCS-inset-dark.mCSB_scrollTools .mCSB_dragger:hover .mCSB_dragger_bar,\n.mCS-inset-2-dark.mCSB_scrollTools .mCSB_dragger:hover .mCSB_dragger_bar,\n.mCS-inset-3-dark.mCSB_scrollTools .mCSB_dragger:hover .mCSB_dragger_bar {\n  background-color: #000;\n  background-color: rgba(0, 0, 0, 0.85);\n}\n\n.mCS-inset-dark.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar,\n.mCS-inset-dark.mCSB_scrollTools\n  .mCSB_dragger.mCSB_dragger_onDrag\n  .mCSB_dragger_bar,\n.mCS-inset-2-dark.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar,\n.mCS-inset-2-dark.mCSB_scrollTools\n  .mCSB_dragger.mCSB_dragger_onDrag\n  .mCSB_dragger_bar,\n.mCS-inset-3-dark.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar,\n.mCS-inset-3-dark.mCSB_scrollTools\n  .mCSB_dragger.mCSB_dragger_onDrag\n  .mCSB_dragger_bar {\n  background-color: #000;\n  background-color: rgba(0, 0, 0, 0.9);\n}\n\n.mCS-inset-dark.mCSB_scrollTools .mCSB_draggerRail,\n.mCS-inset-2-dark.mCSB_scrollTools .mCSB_draggerRail,\n.mCS-inset-3-dark.mCSB_scrollTools .mCSB_draggerRail {\n  background-color: #000;\n  background-color: rgba(0, 0, 0, 0.1);\n}\n\n.mCS-inset-dark.mCSB_scrollTools .mCSB_buttonUp,\n.mCS-inset-2-dark.mCSB_scrollTools .mCSB_buttonUp,\n.mCS-inset-3-dark.mCSB_scrollTools .mCSB_buttonUp {\n  background-position: -112px -72px;\n}\n\n.mCS-inset-dark.mCSB_scrollTools .mCSB_buttonDown,\n.mCS-inset-2-dark.mCSB_scrollTools .mCSB_buttonDown,\n.mCS-inset-3-dark.mCSB_scrollTools .mCSB_buttonDown {\n  background-position: -112px -92px;\n}\n\n.mCS-inset-dark.mCSB_scrollTools .mCSB_buttonLeft,\n.mCS-inset-2-dark.mCSB_scrollTools .mCSB_buttonLeft,\n.mCS-inset-3-dark.mCSB_scrollTools .mCSB_buttonLeft {\n  background-position: -120px -112px;\n}\n\n.mCS-inset-dark.mCSB_scrollTools .mCSB_buttonRight,\n.mCS-inset-2-dark.mCSB_scrollTools .mCSB_buttonRight,\n.mCS-inset-3-dark.mCSB_scrollTools .mCSB_buttonRight {\n  background-position: -120px -128px;\n}\n\n/* theme \"inset-2\", \"inset-2-dark\" */\n\n.mCS-inset-2.mCSB_scrollTools .mCSB_draggerRail,\n.mCS-inset-2-dark.mCSB_scrollTools .mCSB_draggerRail {\n  background-color: transparent;\n  border-width: 1px;\n  border-style: solid;\n  border-color: #fff;\n  border-color: rgba(255, 255, 255, 0.2);\n  -webkit-box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n}\n\n.mCS-inset-2-dark.mCSB_scrollTools .mCSB_draggerRail {\n  border-color: #000;\n  border-color: rgba(0, 0, 0, 0.2);\n}\n\n/* theme \"inset-3\", \"inset-3-dark\" */\n\n.mCS-inset-3.mCSB_scrollTools .mCSB_draggerRail {\n  background-color: #fff;\n  background-color: rgba(255, 255, 255, 0.6);\n}\n\n.mCS-inset-3-dark.mCSB_scrollTools .mCSB_draggerRail {\n  background-color: #000;\n  background-color: rgba(0, 0, 0, 0.6);\n}\n\n.mCS-inset-3.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar {\n  background-color: #000;\n  background-color: rgba(0, 0, 0, 0.75);\n}\n\n.mCS-inset-3.mCSB_scrollTools .mCSB_dragger:hover .mCSB_dragger_bar {\n  background-color: #000;\n  background-color: rgba(0, 0, 0, 0.85);\n}\n\n.mCS-inset-3.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar,\n.mCS-inset-3.mCSB_scrollTools\n  .mCSB_dragger.mCSB_dragger_onDrag\n  .mCSB_dragger_bar {\n  background-color: #000;\n  background-color: rgba(0, 0, 0, 0.9);\n}\n\n.mCS-inset-3-dark.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar {\n  background-color: #fff;\n  background-color: rgba(255, 255, 255, 0.75);\n}\n\n.mCS-inset-3-dark.mCSB_scrollTools .mCSB_dragger:hover .mCSB_dragger_bar {\n  background-color: #fff;\n  background-color: rgba(255, 255, 255, 0.85);\n}\n\n.mCS-inset-3-dark.mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar,\n.mCS-inset-3-dark.mCSB_scrollTools\n  .mCSB_dragger.mCSB_dragger_onDrag\n  .mCSB_dragger_bar {\n  background-color: #fff;\n  background-color: rgba(255, 255, 255, 0.9);\n}\n\n/* ---------------------------------------- */\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
